'use strict';

/* jshint -W098 */
angular.module('mean.foreman').controller('ForemanPhaseReportController', ['$scope', 'Users', 'Global', 'Foreman', 'MeanUser', 'ProjectBids', 'ProjectTasks', '$filter', 'Projects', '$location', 'ProjectHours', 'Materials', '$window', 'ProjectMaterials', 'Builders', 'ProjectEquipments', 'Equipments', 'tradeCodeService', 'userService', 'Trades', 'contactService', 'foremanPhaseService', 'ProjectContacts', 'toaster', '$http', 'ngDialog', 'taskListService', 'Options', 'foremanAdjustCombinedQuantitiesService', 'aceUtils', '$q', '$state', 'projectOptionService','Inventory', 'ProjectMaterialSnapshots', '$loading',
  function($scope, Users, Global, Foreman, MeanUser, ProjectBids, ProjectTasks, $filter, Projects, $location, ProjectHours, Materials, $window, ProjectMaterials, Builders, ProjectEquipments, Equipments, tradeCodeService, userService, Trades, contactService, foremanPhaseService, ProjectContacts, toaster, $http, ngDialog, taskListService, Options, foremanAdjustCombinedQuantitiesService, aceUtils, $q, $state, projectOptionService, Inventory, ProjectMaterialSnapshots, $loading) {
    $scope.global = Global;
    $scope.package = {
      name: 'foreman'
    };

    $scope.current_phases = [];
    $scope.current_tasks = [];
    $scope.my_tasks = [];
    $scope.my_bids = [];
    $scope.my_projects = [];
    $scope.projects = [];
    $scope.user = MeanUser.user;
    $scope.selectedPhase = {};
    $scope.showMatList = false;
    $scope.showReport = false;
    $scope.showConsolidatedReport = false;
    $scope.materials_list = [];
    $scope.equipment_list = [];
    $scope.builder = '';
    $scope.mtcName = '';
    $scope.mtcCode = '';
    $scope.divisionName = '';
    $scope.divisionCode = '';
    $scope.job_name = '';
    $scope.job_code = 0;
    $scope.trade_manager = '';
    $scope.foreman = '';
    $scope.report_date = '';
    $scope.start_date = '';
    $scope.consolidated_materials_list = [];
    $scope.consolidated_equipment_list = [];
    $scope.materialdb = [];
    $scope.equipmentdb = [];
    $scope.selectedReport = {};
    $scope.dateFormat = 'MMM D, YYYY';
    $scope.material_reports = [];
	$scope.equipment_reports = [];
	$scope.submitted_material_reports = [];
	$scope.submitted_equipment_reports = [];
	$scope.available_lots = [];
	$scope.all_materials = [];
	$scope.submittingReport = false;
	$scope.currentForemanNote = '';
	$scope.trade = {};
	$scope.need_emails = true;
	$scope.lots = [];
	$scope.tasks = [];
	$scope.email_contacts = [];
    $scope.just_print = false;
    $scope.print_as_foreman = false;
    $scope.new_material = {};
    $scope.inventoryInvoice = [];
    $scope.show_spinner = false;
    $scope.minDate = moment().format($scope.dateFormat);

    $scope.menu_items = ['Materials', 'Equipment'];
    $scope.mItem = 'Materials';

    // $scope.sortType = ['report_date', 'supplier', 'task_code'];
    // $scope.equipSortType = ['report_date', 'supplier', 'task_code'];
    $scope.sortType = ['task_code', 'lot', 'supplier'];
    $scope.equipSortType = ['task_code', 'lot', 'supplier'];
    $scope.reportSortType = ['name', 'bid_note', 'lot'];
    $scope.sortReverse = false;
    $scope.equipSortReverse = false;
    $scope.reportSortReverse = false;
    $scope.is_manager = false;
    $scope.is_foreman = false;
    $scope.is_admin = false;
    $scope.showSetup = false;

    $scope.dateFormat = 'MMM D, YYYY';

    $scope.onSelect = function(item) {
    	$scope.mItem = item;
    };

    $scope.init = function() {
    	$scope.user.roles.forEach(function(role) {
    		if(role === 'tm_admin') {
    			$scope.is_admin = true;
                $scope.is_manager = true;
    		} else if(role === 'tm_office') {
                $scope.is_admin = true;
                $scope.is_manager = true;
            } else if (role === 'tm') {
                $scope.is_manager = true;
            } else if(role === 'foreman') {
            	$scope.is_foreman = true;
            }
        });

        userService.getMainAccount($scope.user.username).then(function(main_account) {
            $scope.main_account = main_account;
            $scope.getInventories();
            contactService.getMyContacts($scope.main_account._id).then(function(contacts) {
                $scope.builders = [];
                console.log(contacts,'contacts')
                Trades.query({'main_account_id': $scope.main_account._id}, function(trade) {
                    //$scope.companyFactors = trade[0].costs;
                    $scope.trade = trade[0];
                    trade[0].company_code =
                        aceUtils.padDigits(trade[0].company_code, 3);
                    trade[0].trade_code = tradeCodeService.getCode(trade[0].trade);
                    $scope.builders.push(trade[0]);
                });

                contacts['builders'] && contacts['builders'].forEach(function(builder) {
                    Builders.query({'builder': builder._id}, function(builders) {
                        if(builders.length === 0) return;
                        builders[0].company_code =
                            aceUtils.padDigits(builders[0].company_code, 3);
                        builders[0].trade_code = '00';
                        $scope.builders.push(builders[0]);
                    });
                });
            });
        });
    };

    $scope.getInventories = function () {
        Inventory.query({ type: 'formanEntry', 'userId': $scope.main_account._id }, function(inventories) {
            $scope.inventoryInvoice = inventories;
        });
    }

    $scope.changeBuilder = function(builder) {
        $scope.my_projects = [];

    	if($scope.is_admin) {
    		Projects.query({
                'type': 'NamesOnly',
                'company_code': $scope.selectedBuilder.company_code,
                'trade_code': $scope.selectedBuilder.trade_code,
                'complete': false }, function(projects) {
	            //if(projects.length === 0) return;

	            $scope.my_projects = projects;
	        });
    	} else if($scope.is_manager) {
	    	Projects.query({
                'type': 'NameOnlyManagerProjects',
                'company_code': $scope.selectedBuilder.company_code,
                'trade_code': $scope.selectedBuilder.trade_code,
                'complete': false,
	    		'manager': $scope.user.username }, function(projects) {
	            //if(projects.length === 0) return;

	            $scope.my_projects = projects;
	        });
	    } else if($scope.is_foreman) {
	    	Projects.query({
                'type': 'findForemanProjectNames',
                'company_code': $scope.selectedBuilder.company_code,
                'trade_code': $scope.selectedBuilder.trade_code,
                'complete': false,
                'foreman': $scope.user.username}, function(projects) {
	            //if(projects.length === 0) return;

	            $scope.my_projects = projects;
	        });
	    }

        $scope.selectedProject = '';
        $scope.selectedReport = '';
        $scope.selectedPhase = '';
    };

	$scope.changeProject = function(project) {
        $scope.show_spinner = true;
        Projects.query({'_id': project._id}, function(projects) {
            if(projects.length !== 1)  {
                toaster.pop('error', 'We Got Problems');
                return;
            }

    		$scope.selectedProject = projects[0];

            var trade = $filter('filter')($scope.selectedProject.trades, {
                'name': $scope.user.trade[0] }, true);

            if(trade.length !== 1) {
                toaster.pop('error', 'Trade Data', 'Cannot determine trade.  Contact admin.');
                return;
            }

            $scope.companyFactors = trade[0].company_factors;
            if(angular.isUndefined($scope.companyFactors.equipment_tax)) {
                $scope.companyFactors.equipment_tax = 0;
            }

            Options.query({ 'project_id': $scope.selectedProject._id, 'complete': false },
                function(options) {
                if(options.length > 1) {
                    toaster.pop('error', 'Trade Options Error', 'Too many options for this project.  Contact Admin.');
                    //return;
                }
                $scope.trade_options = options[0];
            });

    		if($scope.is_admin) {
    			ProjectTasks.query({'project_id': $scope.selectedProject._id,
                        //'complete': false,
    					'trade': $scope.user.trade[0] }, function(tasks) {
    		    	//get all of the tasks that the current foreman user is assigned
    		    	//and build a list of projects
    		    	$scope.my_tasks = tasks;
                    if(!$scope.my_tasks[0]) {
                        toaster.pop('error', 'Project Tasks Error', 'No tasks found. Check project info.');
                        return;
                    }
    		    	$scope.current_phases = [];
    				$scope.selectedPhase = '';
    				$scope.selectedReport = {};
    				$scope.showMatList = false;

    		    	_.each($scope.my_tasks, function(task) {
    		    		var in_list = $filter('filter')($scope.current_phases, {
    		    			'name': task.phase}, true);

    		    		if(in_list.length === 0) {
    		    			$scope.current_phases.push({
    		    				name: task.phase
    		    			});
    		    		}
    		    	});

    		    	$scope.current_phases = $filter('orderBy')($scope.current_phases, 'name');

    		    	$scope.current_phases.unshift({
    					name: 'Setup'
    				});

    		    	//may want to add code for multiple foreman but no need
    		    	//now since it is understood that one forman per project/task/trade
    		    	//we're just going to get the foreman info from the first task
    		    	Users.query({'username': $scope.my_tasks[0].foreman.username}, function(users) {
    		    		if(users.length !== 1) {
    		    			alert('There was a problem getting the foremans user info.  Contact Admin.');
    		    			return;
    		    		}

    		    		$scope.foreman_info = users[0];
    		    	});

    				ProjectBids.query({
    							'project_id': $scope.selectedProject._id,
                                'complete': false,
    							'trade': $scope.user.trade[0] }, function(bids) {
    					$scope.my_bids = bids;
                        $scope.show_spinner = false;
    				});
    			});
    		} else if($scope.is_manager) {
    			ProjectTasks.query({'project_id': $scope.selectedProject._id,
    					'trade_manager_id': $scope.user._id,
                        //'complete': false,
    					'trade': $scope.user.trade[0] }, function(tasks) {
    		    	//get all of the tasks that the current foreman user is assigned
    		    	//and build a list of projects
    		    	$scope.my_tasks = tasks;
                    if(!$scope.my_tasks[0]) {
                        toaster.pop('error', 'Project Tasks Error', 'No tasks found. Check project info.');
                        return;
                    }
    		    	$scope.current_phases = [];
    				$scope.selectedPhase = '';
    				$scope.selectedReport = {};
    				$scope.showMatList = false;
    				if($scope.my_tasks.length === 0) {
    					$scope.current_phases.push({
    						name: 'NONE'
    					});

    					$scope.selectedPhase = $scope.current_phases[0];

    					return;
    				}

    		    	_.each($scope.my_tasks, function(task) {
                        var in_list = $filter('filter')($scope.current_phases, {
                            'name': task.phase}, true);

                        if(in_list.length === 0) {
                            $scope.current_phases.push({
                                name: task.phase
                            });
                        }
                    });

                    $scope.current_phases = $filter('orderBy')($scope.current_phases, 'name');

    		    	//may want to add code for multiple foreman but no need
    		    	//now since it is understood that one forman per project/task/trade
    		    	//we're just going to get the foreman info from the first task
    		    	Users.query({'username': $scope.my_tasks[0].foreman.username}, function(users) {
    		    		if(users.length !== 1) {
    		    			alert('There was a problem getting the foremans user info.  Contact Admin.');
    		    			return;
    		    		}

    		    		$scope.foreman_info = users[0];
    		    	});

    				ProjectBids.query({
    							'project_id': $scope.selectedProject._id,
                                'complete': false,
    							'trade': $scope.user.trade[0] }, function(bids) {
                                    console.log(bids,'bids')
    					$scope.my_bids = bids;
                        $scope.show_spinner = false;
    				});
    			});
    		} else if($scope.is_foreman) {
    			$scope.foreman_info = $scope.user;

    			ProjectTasks.query({'project_id': $scope.selectedProject._id,
    					'foreman.username': $scope.user.username,
                        //'complete': false,
    					'trade': $scope.user.trade[0] }, function(tasks) {
    		    	//get all of the tasks that the current foreman user is assigned
    		    	//and build a list of projects
    		    	$scope.my_tasks = tasks;
                    if(!$scope.my_tasks[0]) {
                        toaster.pop('error', 'Project Tasks Error', 'No tasks found. Check project info.');
                        return;
                    }
    		    	$scope.current_phases = [];
    				$scope.selectedPhase = '';
    				$scope.selectedReport = {};
    				$scope.showMatList = false;
    				if($scope.my_tasks.length === 0) {
    					$scope.current_phases.push({
    						name: 'NONE'
    					});

    					$scope.selectedPhase = $scope.current_phases[0];

    					return;
    				}

    		    	$scope.my_tasks.forEach(function(task) {
    		    		var in_list = $filter('filter')($scope.current_phases, {
                            'name': task.phase}, true);

    		    		if(in_list.length === 0) {
    		    			$scope.current_phases.push({
    		    				name: task.phase
    		    			});
    		    		}
    		    	});

    				ProjectBids.query({
    							'project_id': $scope.selectedProject._id,
                                'complete': false,
    							'trade': $scope.user.trade }, function(bids) {
    					$scope.my_bids = bids;
                        $scope.show_spinner = false;
    				});
    			});
    		}
        });
	};

    $scope.applyBidTaskMultiple = function(bid, multiple) {
        console.log('apply bid multiple');
        _.each(bid.subtasks, function(subtask) {
            subtask.quantity *= multiple;
            subtask.current_net_pay *= multiple;
            subtask.hours_allowed *= multiple;
            subtask.labor_total *= multiple;
            subtask.material_total *= multiple;
            subtask.equipment_total *= multiple;
            subtask.is_multiple = true;
        });

        _.each(bid.materials, function(mat) {
            mat.quantity *= multiple;
            mat.delivery_price *= multiple;
            mat.materials_subtotal *= multiple;
            mat.is_multiple = true;
        });

        _.each(bid.equipment, function(mat) {
            mat.quantity *= multiple;
            mat.delivery_price *= multiple;
            mat.materials_subtotal *= multiple;
            mat.is_multiple = true;
        });
    };

    $scope.playActiveOptionsOnBid = function(lot_info, bids, task) {
        if(lot_info.active_options.length === 0) return;

        var trades_array = [];
        trades_array.push($scope.trade);

        _.each(lot_info.active_options, function(option) {
            var my_opt = $filter('filter')($scope.trade_options.options, {
                'number': option.number}, true)[0];

            var tradeInfo = $filter('filter')(option.totals, {
                'trade': $scope.user.trade[0] }, true)[0];

            var subtasks = $filter('filter')(my_opt.subtasks, {
                'code': task.task_code, 'plan': task.plan_code}, true);
            subtasks = $filter('filter')(subtasks, {
                'revision': tradeInfo.option_revision}, true);

            var is_multiple = (tradeInfo.multiple > 1)?true: false;

            var item = {
                'revision': tradeInfo.option_revision,
                'lot': task.lot, //lot number
                'number': option.number, //option number
                'phase': task.phase,
                'is_multiple': is_multiple,
                'multiple': tradeInfo.multiple,
            }

            //apply the options to the bid task
            var new_bid_tasks = projectOptionService.findBidSubtasksForOptionUpdates(
                item, lot_info, subtasks, bids, trades_array, is_multiple);

            //if we an update set as the bid task
            if(new_bid_tasks.length > 0) {
                bids = new_bid_tasks;
            }

            _.each(bids, function(task) {
                if(tradeInfo.multiple > 1)
                    $scope.applyBidTaskMultiple(task, tradeInfo.multiple);
            });
        });
    };

	$scope.changePhase = function(phase) {
        $scope.show_spinner = true;
		if(!phase) return;
        console.log($scope.my_bids, '$scope.my_bids phase')
		$scope.selectedReport = {};
		$scope.material_reports = [];
		$scope.equipment_reports = [];
        $scope.submitted_material_reports = [];
        $scope.submitted_equipment_reports = [];

		if(phase.name === 'Setup') {
			$scope.showSetup = true;
            $scope.show_spinner = false;
			return;
		}

		$scope.showSetup = false;

		ProjectMaterials.query({
            'project_id': $scope.selectedProject._id,
            'complete': false,
            'manually_entered': false,
            'phase': phase.name}, function(materialdb) {
			$scope.materialdb = materialdb;

			ProjectEquipments.query({
                'project_id': $scope.selectedProject._id,
                'complete': false,
                'manually_entered': false,
                'phase': phase.name}, function(equipmentdb) {

				$scope.equipmentdb = equipmentdb;
                console.log('building phase reports');

				//we need to build a list by the task code and by different suppliers
				//first lets filter out tasks that are associated to this phase
				var list = $filter('filter')($scope.my_tasks, {'phase': phase.name}, true);

				//now lets order our tasks by task code
				list = $filter('orderBy')(list, 'task_code');

				//now we need to iterate over our current task list and grab
				//the associated bid.  The bid will have the material and
				//equipment information we need to build off of.
                var unique_lot_data = [];
                var lot_data = [];

                unique_lot_data = (_.chain(list).map(function(item) { return item.lot }).uniq().value());
                unique_lot_data = $filter('orderBy')(unique_lot_data);
                _.each(unique_lot_data, function(data) {
                    lot_data.push({
                        item: data
                    });
                });

				_.each(list, function(task) {
                    var bids = $filter('filter')($scope.my_bids, {
                        'task_code': task.task_code, 'plan_code': task.plan_code }, true);

                    if(task.phase === '00' && task.lot === '003') {
                        console.log('found the task im looking for');
                    }

                    bids = angular.copy(bids);

					var supplier_list = [];
					var material_list = [];
					var equipment_list = [];
					var time = moment(task.start_date).subtract(3, 'days').format('MMM DD, YYYY');

                    var lot_info = $filter('filter')($scope.selectedProject.lots, {
                        'number': task.lot, 'phase': task.phase }, true);

                    if(lot_info.length !== 1) {
                        toaster.pop('error', 'foreman_phase line 326',
                            'Problem getting the lot information');
                    } else {
                        var bid_opt = $filter('filter')(bids, {'phase': task.phase, 'lot': task.lot}, true);

                        if(bid_opt.length !== 0) {
                            console.log('This is an option bid');
                            bids = bid_opt;
                        } else {
                            var trade_rev = $filter('filter')(lot_info[0].revisions, {
                                'trade': $scope.user.trade[0] }, true)[0];

                            var bid_rev = $filter('filter')(bids, {'revision': trade_rev.revision}, true);
                            if(bid_rev.length !== 1) {
                                bid_rev = $filter('filter')(bids, {'latest': true}, true);
                                if(bid_rev.length === 1) {
                                    bids = bid_rev;
                                    console.log('We found the bid that matches phase/lot ' + 
                                        lot_info[0].phase + '/' + lot_info[0].number);
                                } else {
                                    var bid_pic = null;
                                    var generic_bid = null;
                                    _.each(bid_rev, function(bid) {
                                        if(bid.phase == lot_info[0].phase && bid.lot == lot_info[0].number) {
                                            bid_pic = bid;
                                        }
                                        if(!bid.phase && !bid.lot) {
                                            generic_bid = bid;
                                        }
                                    })
                                    if(bid_pic) {
                                        console.log('We found a bid that matches phase/lot ' + bid_pic.phase + '/' + bid_pic.lot);
                                        bids = [bid_pic]
                                    } else if(generic_bid) {
                                        console.log('Using the generic bid record for phase/lot ' +
                                            lot_info[0].phase + '/' + lot_info[0].number);
                                        bids = [generic_bid];
                                    } else {
                                        console.log('Could not find a bid record to use for phase/lot ' +
                                            lot_info[0].phase + '/' + lot_info[0].number);
                                        bids = null;
                                    }
                                }
                            } else if(bid_rev.length > 1) {
                                //we got problems
                                console.log('WE HAVE PROBLEMS');
                                toaster.pop('error', 'Lot Bid Error',
                                    task.phase + '/' + task.lot + ' has issues...not processing');
                                bids = null;
                            } else {
                                bids = bid_rev;
                            }
                        }

                        if(bids) {
                            if(task.plan_code !== 'T&M') {
                                _.each(bids[0].materials, function(mat) {
            						material_list = [];
            						var supplier = $filter('filter')($scope.material_reports, {
                                        'task_code': task.task_code,
                                        'supplier': mat.supplier,
                                        'isInventory': mat.isInventory
                                    }, true);

                                    var color_code = $filter('filter')(mat.color_scheme, {
                                        'category': lot_info[0].color_scheme}, true);

                                    var task_color = $filter('filter')(task.color_codes, {
                                        'material_name': mat.name,
                                        'material_note': (mat.note)?mat.note:'' }, true);

                                    var code = '';
                                    if(task_color.length === 1) {
                                        code = task_color[0].code;
                                    } else if(color_code.length === 1) {
                                        code = color_code[0].option;
                                    }

                                    if(task.phase == '00' && task.lot == '001')
                                        console.log("phase/task 00/001 found again");

                                    material_list.push({
                                        lot: task.lot,
                                        task_code: task.task_code,
                                        plan_code: task.plan_code,
                                        name: mat.name,
                                        bid_note: (mat.note)?mat.note:'',
                                        color_code: code,
                                        bid_quantity: mat.quantity,
                                        quantity: mat.quantity,
                                        price_per_order: mat.price_per_order,
                                        delivery_price: mat.delivery_price,
                                        sales_tax: 0,
                                        sub_total: 0,
                                        total: 0,
                                        isInventory: mat.isInventory || false
                                    });

            						if(material_list.length !== 1) {
            							console.log('Material ' + mat.name + ' is a valid material for plan ' +
                                            task.plan_code + ', but it is not a valid material for lot ' + task.lot);
            						} else {
                						if(supplier.length === 0) {
                							//this is the first that we've seen this supplier so we have to build
                							//the main report
                                            var in_db = $filter('filter')($scope.materialdb, {
                                                'project_id': $scope.selectedProject._id,
                                                'phase': task.phase,
                                                'main_report': true,
                                                'supplier': mat.supplier,
                                                'task_code': task.task_code,
                                                'isInventory': mat.isInventory
                                             }, true);

                                            if(in_db.length === 0) {
                    							var report = new ProjectMaterials({
                                                    report_date: moment(time),
                                                    delivery_date: moment(task.start_date),
                                                    start_date: moment(task.start_date),
                    							    trade: $scope.foreman_info.trade[0],
                    							    task_name: task.task_name,
                    							    task_code: task.task_code,
                    							    project_id: $scope.selectedProject._id,
                                                    lots: angular.copy(lot_data),
                                                    main_report: true,
                                                    sub_report_number: 0,
                    							    project_task_id: task._id,
                    							    foreman_id: $scope.foreman_info._id,
                                                    job_code: $scope.selectedProject.job_code,
                                                    company_code: $scope.user.contractor_code,
                    							    phase: phase.name,
                    							    supplier: mat.supplier,
                    							    isInventory: mat.isInventory,
                    							    bid_total: 0,
                                                    materials: material_list,
                                                    userId: $scope.main_account._id
                    							});
                                                $scope.material_reports.push(report);
                                            } else if(in_db.length === 1) {
                                                in_db[0].delivery_date = moment(in_db[0].delivery_date);
                                                $scope.material_reports.push(in_db[0]);
                                            } else {
                                                console.log('got too many items back from the database');
                                                // toaster.pop('warning', 'Too Many Supplier/Task',
                                                //     'This is unexpected and should not be happening.  There are multiple main reports for the same supplier/task combination.  Contact Admin.');
                                                _.each(in_db, function(db) {
                                                    db.delivery_date = moment(db.delivery_date);
                                                    $scope.material_reports.push(db);
                                                });
                                            }

                						} else if(supplier.length === 1) {
                							//check if task start date is earlier than current.
                							if(moment(task.start_date).isBefore(supplier[0].start_date)) {
                								supplier[0].start_date = moment(task.start_date);
                							}
                                            //if there is an _id then it's a saved main report
                                            //and we don't want to add anything to it
                                            if(!supplier[0]._id)
                							  supplier[0].materials.push(material_list[0]);
                						} else {
                                            var report_found = false;
                                            _.each(supplier, function(sup_rpt) {
                                                if(sup_rpt.manually_entered === false) {
                                                    if(report_found === false) {
                                                        if(moment(task.start_date).isBefore(sup_rpt.start_date)) {
                                                            sup_rpt.start_date = moment(task.start_date);
                                                        }

                                                        if(!sup_rpt._id)
                                                          sup_rpt.materials.push(material_list[0]);
                                                        report_found = true;
                                                    } else if(report_found === true) {
                                                        console.log('not sure we should be here')
                                                    }
                                                }
                                            });
                						}
                                    }
                                });

                                // combined inventory phases
                                var tempMaterialReport = [];
                                var copyArraysData = JSON.parse(JSON.stringify($scope.material_reports));
                                _.each($scope.material_reports, function(matReport, indexNo) {
                                    if(matReport.isInventory) {
                                        var ivFound = tempMaterialReport.findIndex(function(iMat) {
                                            return (iMat.isInventory && iMat.task_code == matReport.task_code && iMat.phase == matReport.phase);
                                            });
                                        if(ivFound !== -1) {
                                            _.each(copyArraysData, function(fReport) {
                                                if(fReport['isInventory'] === matReport.isInventory && fReport['task_code'] === matReport.task_code && fReport['phase'] === matReport.phase) {
                                                    var tempMats = tempMaterialReport[ivFound].materials;
                                                    tempMaterialReport[ivFound].materials = tempMats.concat(matReport.materials);
                                                }
                                            })
                                        } else {
                                            tempMaterialReport.push(matReport);
                                            copyArraysData.splice(indexNo, 1);
                                        }
                                    } else {
                                        tempMaterialReport.push(matReport);
                                    }
                                });

                                $scope.material_reports = tempMaterialReport;
                                
            					supplier_list = [];

            					_.each(bids[0].equipment, function(eq) {
            						equipment_list = [];

            						var supplier = $filter('filter')($scope.equipment_reports, {
                                        'task_code': task.task_code,
                                        'supplier': eq.supplier}, true);

            						equipment_list.push({
            					        lot: task.lot,
            					        task_code: task.task_code,
            					        plan_code: task.plan_code,
            					        name: eq.name,
            					        bid_note: (eq.note)?eq.note:'',
            					        bid_quantity: eq.quantity,
            					        quantity: eq.quantity,
            					        price_per_order: eq.price_per_order,
            					        delivery_price: eq.delivery_price,
                                        equipment_tax: 0,
            					        sub_total: 0,
            					        total: 0
            						});

                                    if(equipment_list.length !== 1) {
                                        alert('There is a problem with the material list.  Contact Admin.');
                                        return;
                                    }

            						if(supplier.length === 0) {
            							//this is the first that we've seen this supplier so we have to build
            							//the main report
                                        var in_db = $filter('filter')($scope.equipmentdb, {
                                            'project_id': $scope.selectedProject._id,
                                            'phase': task.phase,
                                            'main_report': true,
                                            'supplier': eq.supplier,
                                            'task_code': task.task_code }, true);

                                        if(in_db.length === 0) {
                							var report = new ProjectEquipments({
                                                report_date: moment(time),
                                                delivery_date: moment(task.start_date),
                                                start_date: moment(task.start_date),
                							    trade: $scope.foreman_info.trade[0],
                							    task_name: task.task_name,
                							    task_code: task.task_code,
                							    project_id: $scope.selectedProject._id,
                							    project_task_id: task._id,
                							    foreman_id: $scope.foreman_info._id,
                                                lots: angular.copy(lot_data),
                                                main_report: true,
                                                sub_report_number: 0,
                                                job_code: $scope.selectedProject.job_code,
                                                company_code: $scope.user.contractor_code,
                							    phase: phase.name,
                							    supplier: eq.supplier,
                							    bid_total: 0,
                							    equipment: equipment_list
                							});
                							$scope.equipment_reports.push(report);
                                        } else if(in_db.length === 1) {
                                            in_db[0].delivery_date = moment(in_db[0].delivery_date);
                                            $scope.equipment_reports.push(in_db[0]);
                                        } else {
                                            conosole.log('got too many items back from the database');
                                        }
            						} else if(supplier.length === 1) {
            							//check if task start date is earlier than current.
            							if(moment(task.start_date).isBefore(supplier[0].start_date)) {
            								supplier[0].start_date = moment(task.start_date);
            							}
            							//supplier[0].equipment.push(equipment_list[0]);
                                        //if there is an _id then it's a saved main report
                                        //and we don't want to add anything to it
                                        if(!supplier[0]._id)
                                          supplier[0].equipment.push(equipment_list[0]);
            						} else {
            							alert('Problem in the supplier list.  Contact Admin');
            							return;
            						}
            					});
                            } else if(task.plan_code === 'T&M') {
                                var in_db = $filter('filter')($scope.materialdb, {
                                    'project_id': $scope.selectedProject._id,
                                    'phase': task.phase,
                                    //'main_report': true,
                                    //'supplier': mat.supplier,
                                    'task_code': task.task_code }, true);

                                _.each(in_db, function(report) {
                                    $scope.material_reports.push(report);
                                });

                                in_db = $filter('filter')($scope.equipmentdb, {
                                    'project_id': $scope.selectedProject._id,
                                    'phase': task.phase,
                                    //'main_report': true,
                                    //'supplier': eq.supplier,
                                    'task_code': task.task_code }, true);

                                _.each(in_db, function(report) {
                                    $scope.equipment_reports.push(report);
                                });
                            } else {
                                toaster.pop('warning', 'Bid Data', 'Did not find a bid for the associated task '
                                    + task.task_code + ' in the foreman phase report.');
                            }
                        }
                    }
                });
                
				//material and equipment reports have been built from
				//the bidding information.  Now we need to run through
				//the numbers and get the bidding total information
				_.each($scope.material_reports, function(report) {
					var consolidated_list = [];

                    if(!report._id) {
    					_.each(report.materials, function(material) {
    						var in_list = [];

                            (material.foreman_note)?
                                material.foreman_note=material.foreman_note.trim():material.foreman_note = '';
                            (material.color_code)?
                                material.color_code=material.color_code.trim():material.color_code='';

                            in_list = $filter('filter')(consolidated_list, {
                                'name': material.name,
                                'foreman_note': (material.foreman_note)?material.foreman_note:'',
                                'color_code': (material.color_code)?material.color_code:'' }, true);

    						if(in_list.length === 0) {
    							consolidated_list.push(angular.copy(material));
    						} else if(in_list.length === 1) {
                                if(in_list[0].lot !== material.lot &&
                                    in_list[0].plan_code !== material.plan_code) {
        							in_list[0].lot = 'Multiple';
        							in_list[0].plan_code = 'Multiple';
                                }
    							in_list[0].bid_quantity += material.bid_quantity;
    							in_list[0].quantity += material.quantity;
    							in_list[0].sub_total += material.quantity * material.price_per_order;
    						} else {
    							alert('Too many of the same items in the consolidated list.  Contact Admin');
    							return;
    						}
    					});

    					//the list of materials have been built but we need to
    					//round up final quantities and adjust totals
    					_.each(consolidated_list, function(material) {
                            if(typeof material.quantity == 'undefined') {
                                console.log('Material ' + material.name + ' (lot/task/plan) ' +
                                    material.lot + '/' + material.task_code + '/' + material.plan_code +
                                    ' has an undefined quantity.  Setting to 1.');
                                material.quantity = 1;
                            }
    						if(Number(material.quantity.toFixed(8)) % 1 !== 0) {
    							material.quantity = $window.Math.ceil(material.quantity);
    						}
    						material.sub_total = material.quantity * material.price_per_order;
    						material.sales_tax = material.sub_total * $scope.companyFactors.sales_tax;
    						report.bid_total += material.sub_total + material.sales_tax +
    								(material.delivery_price * material.quantity);
    					});
                    }
				});

				//need to find out what bidded material reports have been submitted
				//to the database by either saving a change or actual submission
				_.each($scope.material_reports, function(report) {
					var consolidated_list = [];

					var db = $filter('filter')($scope.materialdb, {
							'project_id': $scope.selectedProject._id,
							'phase': phase.name,
                            'main_report': false,
                            //'manually_entered': false,
							'task_code': report.task_code,
							'supplier': report.supplier}, true);

                    _.each(db, function(item) {
                        $scope.submitted_material_reports.push(item);
                    });
				});

                // //lets now look for material reports that have been submitted
                // //in the database view by the admin user
                // var manual_dbs = $filter('filter')($scope.materialdb, {
                //     'manually_entered': true }, true);

                // _.each(manual_dbs, function(item) {
                //     $scope.submitted_material_reports.push(item);
                // });

				//now that we know what reports have been saved to the db now we have
				//to add up the actual quanities and associated costs and
				//replace the bid numbers.
				_.each($scope.submitted_material_reports, function(report) {
					var consolidated_list = [];
					report.actual_total = 0;

					_.each(report.materials, function(material) {
						var in_list = [];

                        (material.foreman_note)?
                            material.foreman_note=material.foreman_note.trim():material.foreman_note = '';
                        (material.color_code)?
                            material.color_code=material.color_code.trim():material.color_code='';

                        in_list = $filter('filter')(consolidated_list, {
                            'name': material.name,
                            'foreman_note': material.foreman_note,
                            'color_code': material.color_code }, true);

						if(in_list.length === 0) {
							consolidated_list.push(angular.copy(material));
						} else if(in_list.length === 1) {
							in_list[0].lot = 'Multiple';
							in_list[0].plan_code = 'Multiple';
							in_list[0].bid_quantity += material.bid_quantity;
							in_list[0].quantity += material.quantity;
							in_list[0].sub_total += material.quantity * material.price_per_order;
						} else {
							alert('Too many of the same items in the consolidated list.  Contact Admin');
							return;
						}
					});

					//the list of materials have been built but we need to
					//round up final quantities and adjust totals
					_.each(consolidated_list, function(material) {
						if(Number(material.quantity.toFixed(8)) % 1 !== 0) {
							material.quantity = $window.Math.ceil(material.quantity);
						}
						material.sub_total = material.quantity * material.price_per_order;
						material.sales_tax = material.sub_total * $scope.companyFactors.sales_tax;
						report.actual_total += material.sub_total + material.sales_tax +
								(material.delivery_price * material.quantity);
					});

					var mat_reports = $filter('filter')($scope.material_reports, {
						'project_id': report.project_id,
						//'project_task_id': report.project_task_id,
						'task_code': report.task_code,
						'task_name': report.task_name,
						'trade': report.trade,
						'supplier': report.supplier
					}, true);

                    _.each(mat_reports, function(mat_report) {
                        if(report !== mat_reports && !mat_reports.main_report) {
                            angular.copy(report, mat_reports);
                            mat_reports.actual_total = report.actual_total;
                        }
                    });
				});

				_.each($scope.equipment_reports, function(report) {
					var consolidated_list = [];

                    if(!report._id) {
    					_.each(report.equipment, function(equipment) {
    						var in_list = [];

                            (equipment.foreman_note)?
                                equipment.foreman_note=equipment.foreman_note.trim():equipment.foreman_note = '';

    						if(equipment.foreman_note) {
    							in_list = $filter('filter')(consolidated_list, {
                                    'name': equipment.name,
                                    'foreman_note': equipment.foreman_note}, true);
    						} else {
                                equipment.foreman_note = '';
    							in_list = $filter('filter')(consolidated_list, {
                                    'name': equipment.name,
                                    'foreman_note': equipment.foreman_note }, true);
    						}

    						if(in_list.length === 0) {
    							consolidated_list.push(angular.copy(equipment));
    						} else if(in_list.length === 1) {
    							in_list[0].lot = 'Multiple';
    							in_list[0].plan_code = 'Multiple';
    							in_list[0].bid_quantity += equipment.bid_quantity;
    							in_list[0].quantity += equipment.quantity;
    							in_list[0].sub_total += equipment.quantity * equipment.price_per_order;
    						} else {
    							alert('Too many of the same items in the consolidated list.  Contact Admin');
    							return;
    						}
    					});

    					//the list of materials have been built but we need to
    					//round up final quantities and adjust totals
    					_.each(consolidated_list, function(equipment) {
    						if(Number(equipment.quantity.toFixed(8)) % 1 !== 0) {
    							equipment.quantity = $window.Math.ceil(equipment.quantity);
    						}
    						equipment.sub_total = equipment.quantity * equipment.price_per_order;
                            equipment.equipment_tax = equipment.sub_total * $scope.companyFactors.equipment_tax;
    						report.bid_total += equipment.sub_total + equipment.equipment_tax +
    								(equipment.delivery_price * equipment.quantity);
    					});
                    }
				});

				//need to find out what bidded material reports have been submitted
				//to the database by either saving a change or actual submission
				_.each($scope.equipment_reports, function(report) {
					var consolidated_list = [];

					var db = $filter('filter')($scope.equipmentdb, {
							'project_id': $scope.selectedProject._id,
							'phase': phase.name,
                            'main_report': false,
							'task_code': report.task_code,
							'supplier': report.supplier}, true);

                    _.each(db, function(item) {
                        $scope.submitted_equipment_reports.push(item);
                    });
				});

				//now that we know what reports have been submitted now we have
				//to add up the actual quanities and associated costs and
				//replace the bid numbers.
				_.each($scope.submitted_equipment_reports, function(report) {
					var consolidated_list = [];
					report.actual_total = 0;

					_.each(report.equipment, function(equipment) {
						var in_list = [];

						if(equipment.foreman_note) {
							in_list = $filter('filter')(consolidated_list, {
                                'name': equipment.name,
                                'foreman_note': equipment.foreman_note}, true);
						} else {
                            equipment.foreman_note = '';
							in_list = $filter('filter')(consolidated_list, {
                                'name': equipment.name,
                                'foreman_note': equipment.foreman_note }, true);
						}

						if(in_list.length === 0) {
							consolidated_list.push(angular.copy(equipment));
						} else if(in_list.length === 1) {
							in_list[0].lot = 'Multiple';
							in_list[0].plan_code = 'Multiple';
							in_list[0].bid_quantity += equipment.bid_quantity;
							in_list[0].quantity += equipment.quantity;
							in_list[0].sub_total += equipment.quantity * equipment.price_per_order;
						} else {
							alert('Too many of the same items in the consolidated list.  Contact Admin');
							return;
						}
					});

					//the list of materials have been built but we need to
					//round up final quantities and adjust totals
					_.each(consolidated_list, function(equipment) {
						if(Number(equipment.quantity.toFixed(8)) % 1 !== 0) {
							equipment.quantity = $window.Math.ceil(equipment.quantity);
						}
						equipment.sub_total = equipment.quantity * equipment.price_per_order;
                        equipment.equipment_tax = equipment.sub_total * $scope.companyFactors.equipment_tax;
						report.actual_total += equipment.sub_total + equipment.equipment_tax +
								(equipment.delivery_price * equipment.quantity);
					});

					var eq_reports = $filter('filter')($scope.equipment_reports, {
						'project_id': report.project_id,
						'project_task_id': report.project_task_id,
						'task_code': report.task_code,
						'task_name': report.task_name,
						'trade': report.trade,
						'supplier': report.supplier
					}, true);

                    _.each(eq_reports, function(eq_report) {
                        if(report !== eq_report && !eq_report.main_report) {
                            angular.copy(report, eq_report);
                            eq_report.actual_total = report.actual_total;
                        }
                    });
				});

				$scope.selectedPhase = phase;
				$scope.showMatList = true;

                //there could be some reports saved to the database that
                //cannot be built due to the user adding a report manually
                //so we'll check here.
                _.each($scope.materialdb, function(db) {
                    var inlist = $filter('filter')($scope.material_reports, {
                        'task_code': db.task_code,
                        'supplier': db.supplier,
                        'main_report': false,
                        'sub_report_number': db.sub_report_number,
                        'project_id': db.project_id }, true);

                    db.delivery_date = moment(db.delivery_date);
                    if(inlist.length === 0) {
                        if(!db.main_report) {
                            $scope.material_reports.push(db);
                        } else if(db.manually_entered) {
                            if($scope.material_reports.indexOf(db) !== -1) {
                                console.log('the material is already in the list');
                            } else {
                                console.log('did not find the material in the list');
                                $scope.material_reports.push(db);
                            }
                        }
                    } else if(inlist.length === 1) {
                        console.log(inlist.length);
                        if(!db.main_report)
                          $scope.material_reports.push(db);
                    }
                });

                _.each($scope.equipmentdb, function(db) {
                    var inlist = $filter('filter')($scope.equipment_reports, {
                        'task_code': db.task_code,
                        'supplier': db.supplier,
                        'main_report': false,
                        'project_id': db.project_id }, true);

                    db.delivery_date = moment(db.delivery_date);
                    if(inlist.length === 0 && !db.main_report) {
                        if($scope.equipment_reports.indexOf(db) !== -1) {
                            console.log('the equipment is already in the list');
                        } else {
                            console.log('did not find the equipment in the list');
                            $scope.equipment_reports.push(db);
                        }
                    } else if(inlist.length === 1) {
                        console.log(inlist.length);
                        if(!db.main_report)
                          $scope.equipment_reports.push(db);
                    }
                });

                $scope.material_reports =
                    foremanPhaseService.removedMerged(
                            $scope.material_reports);

                // _.each($scope.material_reports, function(report) {
                //     _.each(report.materials, function(material) {
                //         var bid_info = $filter('filter')($scope.my_bids, {
                //             'task_code': report.task_code, 'plan_code': material.plan_code }, true);
                //         console.log(bid_info);
                //         //material.color_code is what is saved in the db but the user might have changed it
                //         //bid_info has the most recent color data.
                //         var lot_info = $filter('filter')($scope.selectedProject.lots, {
                //             'number': material.number, 'phase': $scope.selectedPhase.name }, true);


                //     });
                // });

                $scope.equipment_reports =
                    foremanPhaseService.removedMerged(
                            $scope.equipment_reports);

                $scope.lots = $filter('filter')($scope.selectedProject.lots, {
                    'phase': $scope.selectedPhase.name,
                    'scheduled': true, 'complete': false }, true);

                $scope.show_spinner = false;
			});
		});
	};

	$scope.setGlobals = function(trade) {
		$scope.builder = $scope.selectedProject.builder.name;
	    $scope.job_name = $scope.selectedProject.name;
	    $scope.job_code = $scope.selectedProject.job_code;
	    $scope.trade_manager = trade.manager.name;
	    $scope.trade_manager_phone = trade.manager.phone;
	    $scope.supplier = $scope.selectedReport.supplier;
	    $scope.foreman = $scope.foreman_info.name;
	    $scope.trade_code = $scope.selectedProject.trade_code;
	    $scope.company_code = $scope.selectedProject.company_code;
	};

    $scope.selectedMaterialOperation = function(item, e, equipment) {
        e.stopPropagation();

        $scope.returnedLots = {
            selectedLot: '',
            lots: item.lots
        };

        ngDialog.openConfirm({
            template: 'foreman/views/tmpl/foreman-split-material.html',
            scope: $scope,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            if($scope.returnedLots.selectedLot.length === item.lots.length) {
                toaster.pop('error', 'Split Materials Error',
                    'Cannot select all lots to split');
                return;
            }
            if(equipment) {
                $scope.splitEquipmentReport(item);
            } else {
                $scope.splitMaterialReport(item);
            }
        }, function (value) {
            //Do something
            console.log('in the do something section');
        });
    };

    $scope.adjustSplitMaterialQuantityValues = function(item, report, tax) {
        var list = [];

        item.total = item.quantity * item.price_per_order;

        //need to adjust the originial list items from $scope.materials_list
        list = $filter('filter')(report.materials, {
                    'foreman_note': (item.foreman_note)?item.foreman_note:'',
                    'color_code': (item.color_code)?item.color_code:'',
                    'name': item.name}, true);

        var items_total = 0;
        //need to do a weighted average of all similar items
        //first add up all the items in the list
        _.each(list, function(listItem) {
            items_total += listItem.quantity;
        });

        item.sub_total = 0;
        if(items_total) {
            var factor = item.quantity / items_total;
        } else {
            var factor = item.quantity / list.length;
        }

        //now apply the factor back to the list items
        _.each(list, function(listItem) {
            if(listItem.quantity)
              listItem.quantity *= factor;
            else
              listItem.quantity = factor;

            listItem.quantity = Number(listItem.quantity.toFixed(8));
            item.sub_total += listItem.quantity * listItem.price_per_order;
        });

        //update values in the view
        item.sales_tax = item.sub_total * tax;
        item.total = item.sub_total + item.sales_tax + (item.delivery_price * item.quantity);
    };

    $scope.adjustSplitEquipmentQuantityValues = function(item, report, tax) {
        var list = [];

        item.total = item.quantity * item.price_per_order;

        //need to adjust the originial list items from $scope.materials_list
        list = $filter('filter')(report.equipment, {
                    'foreman_note': (item.foreman_note)?item.foreman_note:'',
                    'name': item.name}, true);

        var items_total = 0;
        //need to do a weighted average of all similar items
        //first add up all the items in the list
        _.each(list, function(listItem) {
            items_total += listItem.quantity;
        });

        item.sub_total = 0;
        if(items_total) {
            var factor = item.quantity / items_total;
        } else {
            var factor = item.quantity / list.length;
        }

        //now apply the factor back to the list items
        _.each(list, function(listItem) {
            if(listItem.quantity)
              listItem.quantity *= factor;
            else
              listItem.quantity = factor;

            item.sub_total += listItem.quantity * listItem.price_per_order;
        });

        //update values in the view
        item.sales_tax = item.sub_total * tax;
        item.total = item.sub_total + item.sales_tax + (item.delivery_price * item.quantity);
    };

    $scope.splitMaterialReport = function(item) {
        ProjectMaterials.query({
            'project_id': $scope.selectedProject._id,
            'complete': false,
            'phase': item.phase,
            'task_code': item.task_code,
            'submitted': true  }, function(projMatsDB) {
            var new_report_number = 0;
            if(item._id) {
                //this report has been saved
                new_report_number = item.sub_report_number + 1;
            } else {
                item.sub_report_number = projMatsDB.length;
                new_report_number = item.sub_report_number + 1;
            }
            //item is the main report and has all the lot data we need
            //grab material information from item and place in a
            //new projectMaterials entry.  Copy all the data but
            //make sure to set main_report to false and increment
            //sub_report_number.  Then remove that lot data from
            //the main report
            var materials = [];
            var full_mat_list = [];
            _.each($scope.returnedLots.selectedLot, function(lot) {
                //remove from the reports main lots list
                var idx = item.lots.indexOf(lot);
                item.lots.splice(idx, 1);

                //remove the materials for this lot from the main report
                materials = _.remove(item.materials, function(mat) {
                    return mat.lot === lot.item;
                });

                //Add the removed materials to the full list
                _.each(materials, function(mat) {
                    full_mat_list.push(mat);
                });
            });

            // add main_account_id if not exists
            if(!item.userId) {
                item['userId'] = $scope.main_account._id;
            }

            //don't forget to update bid and actual totals
            var new_report = new ProjectMaterials(item);
            delete new_report._id;
            new_report.materials = full_mat_list;
            new_report.main_report = false;
            new_report.sub_report_number = new_report_number;
            new_report.lots = $scope.returnedLots.selectedLot;
            $scope.material_reports.push(new_report);

            var new_consolidated_list =
                foremanPhaseService.consolidateOnForemanNotes(
                    new_report.materials, $scope.companyFactors.sales_tax, false);

            new_report.bid_total =
                foremanPhaseService.getConsolidatedBidTotal(
                    new_consolidated_list, $scope.companyFactors.sales_tax);

            new_report.actual_total =
                foremanPhaseService.getConsolidatedActualTotal(
                    new_consolidated_list, $scope.companyFactors.sales_tax);

            var consolidated_list =
                foremanPhaseService.consolidateOnForemanNotes(
                    item.materials, $scope.companyFactors.sales_tax, false);

            item.bid_total =
                foremanPhaseService.getConsolidatedBidTotal(
                    consolidated_list, $scope.companyFactors.sales_tax);

            item.actual_total =
                foremanPhaseService.getConsolidatedActualTotal(
                    consolidated_list, $scope.companyFactors.sales_tax);

            _.each(new_consolidated_list, function(item) {
                $scope.adjustSplitMaterialQuantityValues(
                    item, new_report, $scope.companyFactors.sales_tax);
            });

            item.invoice_date = item.delivery_date;
            item.invoice_total = item.actual_total;

            new_report.$save(function(success) {
                $scope.updateDate(success);
                $scope.materialdb.push(success);
                if(item._id) {
                    item.$update(function(response) {
                        $scope.updateDate(response);
                        response.bid_total = response.bid_total;
                    });
                } else {
                    _.each(consolidated_list, function(list_item) {
                        $scope.adjustSplitMaterialQuantityValues(
                            list_item, item, $scope.companyFactors.sales_tax);
                    });
                    item.$save(function(response) {
                        $scope.updateDate(response);
                        response.bid_total = response.bid_total;
                        $scope.materialdb.push(item);
                    });
                }
            });
        });
    };

    $scope.splitEquipmentReport = function(item) {
        ProjectEquipments.query({
            'project_id': $scope.selectedProject._id,
            'complete': false,
            'phase': item.phase,
            'task_code': item.task_code }, function(projMatsDB) {
            var new_report_number = 0;
            if(item._id) {
                //this report has been saved
                new_report_number = item.sub_report_number + 1;
            } else {
                item.sub_report_number = projMatsDB.length;
                new_report_number = item.sub_report_number + 1;
            }
            //item is the main report and has all the lot data we need
            //grab material information from item and place in a
            //new projectMaterials entry.  Copy all the data but
            //make sure to set main_report to false and increment
            //sub_report_number.  Then remove that lot data from
            //the main report
            var equipment = [];
            var full_eq_list = [];
            _.each($scope.returnedLots.selectedLot, function(lot) {
                //remove from the reports main lots list
                var idx = item.lots.indexOf(lot);
                item.lots.splice(idx, 1);

                //remove the equipment for this lot from the main report
                equipment = _.remove(item.equipment, function(mat) {
                    return mat.lot === lot.item;
                });

                //Add the removed equipment to the full list
                _.each(equipment, function(mat) {
                    full_eq_list.push(mat);
                });
            });

            //don't forget to update bid and actual totals
            var new_report = new ProjectEquipments(item);
            delete new_report._id;
            new_report.equipment = full_eq_list;
            new_report.main_report = false;
            new_report.sub_report_number = new_report_number;
            new_report.lots = $scope.returnedLots.selectedLot;
            $scope.equipment_reports.push(new_report);

            var new_consolidated_list =
                foremanPhaseService.consolidateEquipmentOnForemanNotes(
                    new_report.equipment, $scope.companyFactors.equipment_tax);

            new_report.bid_total =
                foremanPhaseService.getConsolidatedEquipmentBidTotal(
                    new_consolidated_list, $scope.companyFactors.equipment_tax);

            new_report.actual_total =
                foremanPhaseService.getConsolidatedEquipmentActualTotal(
                    new_consolidated_list, $scope.companyFactors.equipment_tax);

            var consolidated_list =
                foremanPhaseService.consolidateEquipmentOnForemanNotes(
                    item.equipment, $scope.companyFactors.equipment_tax);

            item.bid_total =
                foremanPhaseService.getConsolidatedEquipmentBidTotal(
                    consolidated_list, $scope.companyFactors.equipment_tax);

            item.actual_total =
                foremanPhaseService.getConsolidatedEquipmentActualTotal(
                    consolidated_list, $scope.companyFactors.equipment_tax);

            _.each(new_consolidated_list, function(item) {
                $scope.adjustSplitEquipmentQuantityValues(
                    item, new_report, $scope.companyFactors.sales_tax);
            });

            item.invoice_date = item.delivery_date;
            item.invoice_total = item.actual_total;

            new_report.$save(function(success) {
                $scope.updateDate(success);
                $scope.equipmentdb.push(success);
                if(item._id) {
                    item.$update(function(response) {
                        $scope.updateDate(response);
                        response.bid_total = response.bid_total;
                    });
                } else {
                    _.each(consolidated_list, function(list_item) {
                        $scope.adjustSplitEquipmentQuantityValues(
                            list_item, item, $scope.companyFactors.sales_tax);
                    });

                    item.$save(function(response) {
                        $scope.updateDate(response);
                        response.bid_total = response.bid_total;
                        $scope.equipmentdb.push(item);
                    });
                }
            });
        });
    };

	$scope.selectedMaterial = function(item) {
		$scope.email_contacts = [];
        var query = (item.project_id._id)?item.project_id._id:item.project_id;
		ProjectContacts.query({'project_id': query}, function(contact) {
			if(contact.length !== 1) {
				toaster.pop('error', 'Project Contact Database', 'There is a problem getting the contact database for this project.');
				return;
			}

			$scope.email_contacts =
				foremanPhaseService.getCompanyEmailContacts(contact[0]);

			$scope.email_contacts = $scope.email_contacts.concat(
				foremanPhaseService.getSupplierEmailContacts(
					contact[0].material_suppliers, item.supplier));

			$scope.materials_list = [];

			if(!item) {
				alert('There was a problem getting the report.  Contact Admin.');
				return;
			}

			$scope.mItem = 'Materials';
			$scope.selectedReport = item;

			$scope.report_date = $scope.selectedReport.report_date;
			$scope.start_date = $scope.selectedReport.start_date;

			var curr_date = moment($scope.selectedReport.start_date);

			var trade = $filter('filter')($scope.selectedProject.trades, {
                'name': $scope.foreman_info.trade[0]}, true);

			if(trade.length !== 1) {
				alert('There was a problem getting the trade from the currently selected project.  Contact Admin.');
				return;
			}

			$scope.setGlobals(trade[0]);

            $scope.selectedReport.materials =
                foremanPhaseService.removeZeroQuantityItems(
                    $scope.selectedReport.materials);

            $scope.selectedReport.materials =
                foremanPhaseService.combineSimilarItems(
                    $scope.selectedReport.materials);

			$scope.mergable_reports =
                foremanPhaseService.getMergableReports(
                    $scope.selectedReport, $scope.material_reports);

			$scope.showReport = true;
			$scope.showMatList = false;
            $scope.submitMaterials();
		});
	};

	$scope.selectedEquipment = function(item) {
		$scope.email_contacts = [];
		ProjectContacts.query({'project_id': item.project_id}, function(contact) {
			if(contact.length !== 1) {
				toaster.pop('error', 'Project Contact Database', 'There is a problem getting the contact database for this project.');
				return;
			}

			$scope.email_contacts =
				foremanPhaseService.getCompanyEmailContacts(contact[0]);

			$scope.email_contacts = $scope.email_contacts.concat(
				foremanPhaseService.getSupplierEmailContacts(
					contact[0].equipment_suppliers, item.supplier));

			$scope.equipment_list = [];

			if(!item) {
				alert('There was a problem getting the report.  Contact Admin.');
				return;
			}

			$scope.mItem = 'Equipment';

			$scope.selectedReport = item;

			$scope.report_date = $scope.selectedReport.report_date;
			$scope.start_date = $scope.selectedReport.start_date;

			var curr_date = moment($scope.selectedReport.start_date);

			var trade = $filter('filter')($scope.selectedProject.trades, {
                'name': $scope.foreman_info.trade[0]}, true);

			if(trade.length !== 1) {
				alert('There was a problem getting the trade from the currently selected project.  Contact Admin.');
				return;
			}

			$scope.setGlobals(trade[0]);

            $scope.selectedReport.equipment =
                foremanPhaseService.removeZeroQuantityItems(
                    $scope.selectedReport.equipment);

            $scope.selectedReport.equipment =
                foremanPhaseService.combineSimilarItems(
                    $scope.selectedReport.equipment);

            $scope.mergable_reports =
                foremanPhaseService.getMergableReports(
                    $scope.selectedReport, $scope.equipment_reports);

			$scope.showReport = true;
			$scope.showMatList = true;
            $scope.submitEquipment();
		});
	};

	$scope.back = function() {
		$scope.materials_list = [];
		$scope.equipment_list = [];
		$scope.builder = '';
	    $scope.job_name = '';
	    $scope.job_code = '';
	    $scope.trade_manager = '';
	    $scope.foreman = '';
	    $scope.mtcName = '';
	    $scope.mtcCode = '';
	    $scope.divisionName = '';
	    $scope.divisionCode = '';
        delete $scope.available_suppliers;
        delete $scope.available_eq_suppliers;

		$scope.showReport = false;
		$scope.showMatList = true;
        $scope.showConsolidatedReport = false;
	};

    $scope.roundUp = function(item) {
        if(!item) return;

        return $window.Math.ceil(Number(item.toFixed(8)));
    };

    $scope.quantityDanger = function(bid_qty, qty, isInventory) {
        if(!bid_qty || !qty || isInventory) return;

        bid_qty = $window.Math.ceil(Number(bid_qty.toFixed(8)));
        qty = Number(qty.toFixed(8));

        return bid_qty < qty;
    }

    $scope.quantityGreen = function(bid_qty, qty, isInventory) {
        if(!bid_qty || !qty || isInventory) return;
        bid_qty = $window.Math.ceil(Number(bid_qty.toFixed(8)));
        qty = Number(qty.toFixed(8));

        return bid_qty > qty;
    }

	$scope.submitMaterials = function() {
		//materials_list has the main list that we need to work from
		//we need to use this list to create the consolidated list
		var mat_list = $filter('orderBy')($scope.selectedReport.materials, ['name', 'lot']);
		var curr_name;

		$scope.consolidated_materials_list = [];

        var manually_entered = $scope.selectedReport.manually_entered;

		//use name to control
		//mat_list.forEach(function(material) {
        _.each(mat_list, function(material) {
			var in_list = [];

            (material.foreman_note)?
                material.foreman_note=material.foreman_note.trim():material.foreman_note = '';
            (material.color_code)?
                material.color_code=material.color_code.trim():material.color_code='';

            in_list = $filter('filter')($scope.consolidated_materials_list, {
                'name': material.name,
                'foreman_note': material.foreman_note,
                'color_code': material.color_code }, true);

			material.quantity = Math.abs(material.quantity);

			if(in_list.length === 0) {
				material.lots = [];
				material.plans = [];
				material.bid_notes = [];
				material.lots.push({
					name: material.lot
				});
				material.plans.push({
					name: material.plan_code
				});
				material.bid_notes.push({
					lot: material.lot,
					note: (material.bid_note)?material.bid_note:''
				});

                material.manually_entered = manually_entered;

                $scope.consolidated_materials_list.push(angular.copy(material));
			} else if(in_list.length === 1) {
				in_list[0].lots.push({
					name: material.lot
				});
				in_list[0].plans.push({
					name: material.plan_code
				});
				in_list[0].bid_notes.push({
					lot: material.lot,
					note: (material.bid_note)?material.bid_note:''
				});
                if(in_list[0].bid_notes[0].note !== material.bid_note) {
                    in_list[0].bid_note = 'Multiple';
                }

				in_list[0].lot = 'Multiple';
				in_list[0].plan_code = 'Multiple';
				in_list[0].bid_quantity += material.bid_quantity;
				in_list[0].quantity += material.quantity;
				in_list[0].sub_total += material.quantity * material.price_per_order;
			} else {
				alert('Too many of the same items in the consolidated list.  Contact Admin');
				return;
			}
		});

        // var needs_adjustment = false;
        // _.each($scope.consolidated_materials_list, function(item) {
        //     if(!item.adjusted) {
        //         item.quantity = Math.abs(item.quantity);

        //         if(item.quantity % 1 !== 0) {
        //             item.quantity = $window.Math.ceil(item.quantity);
        //         }
        //         item.adjusted = true;
        //         needs_adjustment = true;
        //         $scope.adjustMaterialQuantityValues(item, $scope.companyFactors.sales_tax);
        //     }
        // });

        // if(needs_adjustment) {
        //     foremanAdjustCombinedQuantitiesService.setQuantityValues(
        //         $scope.consolidated_materials_list,
        //         $scope.selectedReport.materials,
        //         $scope.companyFactors.sales_tax);
        // }

        $scope.getReportMaterialTotals();

		$scope.showConsolidatedReport = true;
		$scope.showReport = true;
		$scope.showMatList = false;
	};

    $scope.getReportMaterialTotals = function() {
        $scope.material_sub_total = 0;
        $scope.material_sales_tax = 0;
        $scope.material_delivery_price = 0;
        $scope.material_total = 0;

        //the list of materials have been built but we need to
        //round up final quantities and adjust totals
        _.each($scope.consolidated_materials_list, function(material) {
            if(Number(material.quantity.toFixed(8)) % 1 !== 0) {
                material.quantity = $window.Math.ceil(material.quantity);
            }

            material.sub_total = material.quantity * material.price_per_order;

            if(material.manually_entered) {
                material.sales_tax = 0;
            } else {
                material.sales_tax = material.sub_total * $scope.companyFactors.sales_tax;
            }

            material.total = material.sub_total + material.sales_tax +
                                    (material.delivery_price * material.quantity);

            $scope.material_sub_total += material.sub_total;
            $scope.material_sales_tax += material.sales_tax;
            $scope.material_delivery_price += material.quantity * material.delivery_price;
            $scope.material_total += material.sub_total + material.sales_tax +
                    (material.delivery_price * material.quantity);
        });

        // if(!$scope.selectedReport.adjusted) {
        //     foremanAdjustCombinedQuantitiesService.setQuantityValues(
        //         $scope.consolidated_materials_list,
        //         $scope.selectedReport.materials,
        //         $scope.companyFactors.sales_tax);
        //     $scope.selectedReport.adjusted = true;
        // }
    };

	$scope.submitEquipment = function() {
		//materials_list has the main list that we need to work from
		//we need to use this list to create the consolidated list
		var eq_list = $filter('orderBy')($scope.selectedReport.equipment, ['name', 'lot']);
		var curr_name;

		$scope.consolidated_equipment_list = [];

		_.each(eq_list, function(equipment) {
			var in_list = [];

			if(equipment.foreman_note) {
				in_list = $filter('filter')($scope.consolidated_equipment_list, {
                    'name': equipment.name,
                    'foreman_note': equipment.foreman_note}, true);
			} else {
                equipment.foreman_note = '';
				in_list = $filter('filter')($scope.consolidated_equipment_list, {
                    'name': equipment.name,
                    'foreman_note': equipment.foreman_note }, true);
			}

			equipment.quantity = Math.abs(equipment.quantity);

			if(in_list.length === 0) {
				equipment.lots = [];
				equipment.plans = [];
				equipment.bid_notes = [];
				equipment.lots.push({
					name: equipment.lot
				});
				equipment.plans.push({
					name: equipment.plan_code
				});
				equipment.bid_notes.push({
					lot: equipment.lot,
					note: (equipment.bid_note)?equipment.bid_note:''
				});
				$scope.consolidated_equipment_list.push(angular.copy(equipment));
			} else if(in_list.length === 1) {
				in_list[0].lots.push({
					name: equipment.lot
				});
				in_list[0].plans.push({
					name: equipment.plan_code
				});
				in_list[0].bid_notes.push({
					lot: equipment.lot,
					note: (equipment.bid_note)?equipment.bid_note:''
				});
                if(in_list[0].bid_notes[0].note !== equipment.bid_note) {
                    in_list[0].bid_note = 'Multiple';
                }
				in_list[0].lot = 'Multiple';
				in_list[0].plan_code = 'Multiple';
				in_list[0].bid_quantity += equipment.bid_quantity;
				in_list[0].quantity += equipment.quantity;
				in_list[0].sub_total += equipment.quantity * equipment.price_per_order;
			} else {
				alert('Too many of the same items in the consolidated list.  Contact Admin');
				return;
			}
		});

        $scope.getReportEquipmentTotals();

		$scope.showConsolidatedReport = true;
		$scope.showReport = true;
		$scope.showMatList = false;
	};

    $scope.getReportEquipmentTotals = function() {
        $scope.equipment_sub_total = 0;
        $scope.equipment_tax = 0;
        $scope.equipment_delivery_price = 0;
        $scope.equipment_total = 0

        //the list of equipment have been built but we need to
        //round up final quantities and adjust totals
        _.each($scope.consolidated_equipment_list, function(equipment) {
            if(Number(equipment.quantity.toFixed(8)) % 1 !== 0) {
                equipment.quantity = $window.Math.ceil(equipment.quantity);
            }
            equipment.sub_total = equipment.quantity * equipment.price_per_order;
            equipment.equipment_tax = equipment.sub_total * $scope.companyFactors.equipment_tax;
            equipment.total = equipment.sub_total + equipment.equipment_tax +
                (equipment.delivery_price * equipment.quantity);

            $scope.equipment_sub_total += equipment.sub_total;
            $scope.equipment_tax += equipment.equipment_tax;
            $scope.equipment_delivery_price += equipment.delivery_price * equipment.quantity;
            $scope.equipment_total += equipment.total;
        });
    };

	$scope.getLotText = function() {
		var txt = '';

		_.each($scope.selectedReport.lots, function(lot) {
			txt += lot.item + ', ';
		});

		return txt;
	};

	$scope.getEmailText = function() {
		var txt = '';

        _.each($scope.email_contacts, function(email) {
			txt += email + ', '
		});

		return txt;
	};

	$scope.getConsolidatedSubtotal = function(list) {
		var num = 0;

        _.each(list, function(item) {
			num += item.sub_total;
		});

		return num.toFixed(2);
	};

	$scope.getConsolidatedDelivery = function(list) {
		var num = 0;

        _.each(list, function(item) {
			num += item.delivery_price * item.quantity;
		});

		return num.toFixed(2);
	};

	$scope.getConsolidatedTaxes = function(list) {
		var num = 0;

		if($scope.mItem === 'Equipment') {
            _.each(list, function(item) {
                num += item.equipment_tax;
            });
        } else {
            _.each(list, function(item) {
                num += item.sales_tax;
            });
        }

		return num.toFixed(2);
	};

	$scope.getConsolidatedTotal = function(list) {
		var num = 0;

        _.each(list, function(item) {
			num += item.total;
		});

		return num.toFixed(2);
	};

	$scope.buildTableBody = function(data, columns) {
	    var body = [];

	    body.push(columns);

	    _.each(data, function(row) {
	        var dataRow = [];

	        _.each(columns, function(column) {
	        	if(column === 'sub_total') {
	        		dataRow.push('$ ' + row[column].toFixed(2).toString());
	        	} else if(column === 'quantity'){
	        		dataRow.push(row[column].toFixed(2).toString());
	        	} else if(column === 'price' && $scope.mItem === 'Materials') {
	        		dataRow.push('$ ' + row['price_per_order'].toFixed(2).toString());
	        	} else if(column === 'price' && $scope.mItem === 'Equipment') {
	        		dataRow.push('$ ' + row['price_per_order'].toFixed(2).toString());
	        	} else if(column === 'color_code' && $scope.mItem === 'Equipment') {
                    dataRow.push(' ');
                } else {
                    if(column === 'color_code' || column === 'bid_note') {
                        if(row[column])
    		              dataRow.push(row[column].toString());
                        else
                          dataRow.push('');
                    } else {
                        dataRow.push(row[column].toString());
                    }
		        }
	        })

	        body.push(dataRow);
	    });

	    return body;
	};

	$scope.table = function(data, columns) {
	    return [{
	        table: {
	            headerRows: 1,
	            body: $scope.buildTableBody(data, columns)
	        },
	        fontSize: 10
	    }];
	};

    $scope.printMaterialList = function(list) {
        $scope.just_print = true;

        list = $filter('orderBy')(list, $scope.reportSortType);
        $scope.buildPDF(list);
    };

    $scope.printMaterialListAsForeman = function(list) {
        $scope.just_print = true;
        $scope.is_foreman = true;
        $scope.print_as_foreman = true;
        list = $filter('orderBy')(list, $scope.reportSortType);
        $scope.buildPDF(list);
    };

	$scope.buildPDF = function(consolidated_list) {
        if($scope.selectedReport.hasOwnProperty('materials') && !$scope.selectedReport.materials.length){
                toaster.pop('error', 'Material Error', `Don't have any material in this task.`);
				return;
        }
        if($scope.selectedReport.hasOwnProperty('equipment') && !$scope.selectedReport.equipment.length ){
                toaster.pop('error', 'Equipment Error', `Don't have any equipment in this task.`);
                return;
        }
        
        var supplierName = 'NA';
        if($scope.mItem === 'Materials') {
            supplierName = $scope.selectedReport.materials[0].isInventory
                ? 'Inventory' : $scope.selectedReport.supplier;
        } else {
            supplierName = $scope.selectedReport.supplier;
        }
        var data = consolidated_list;
        var sub_total = 0;
        var tax = 0;
        var dev_price = 0;
        var total = 0;
		if($scope.mItem === 'Materials') {
		  	var list_title = 'Materials List';
            sub_total = $filter('number')($scope.material_sub_total, 2);
            tax = $filter('number')($scope.material_sales_tax, 2);
            dev_price = $filter('number')($scope.material_delivery_price, 2);
            total = $filter('number')($scope.material_total, 2);
		} else if($scope.mItem === 'Equipment') {
			var list_title = 'Equipment List';
            sub_total = $filter('number')($scope.equipment_sub_total, 2);
            tax = $filter('number')($scope.equipment_tax, 2);
            dev_price = $filter('number')($scope.equipment_delivery_price, 2);
            total = $filter('number')($scope.equipment_total, 2);
		} else {
			toaster.pop('error', 'PDF Data Error', 'Problem getting the list');
			return;
		}

        data = foremanPhaseService.pdfRemoveZeroQuantityItems(data);

        data = $filter('orderBy')(data, ['name', 'bid_note', 'lot']);

        var rpt_num = $scope.selectedReport.sub_report_number;

        var po_num = $scope.job_code + '-' + $scope.selectedPhase.name + '-' +
                    $scope.selectedReport.task_code + '-' + rpt_num;

        var supplier_text = $scope.selectedReport.materials[0].isInventory ? 'Inventory' : $scope.selectedReport.supplier;

        var po_section = {
            width: '*',
            stack: [{
                text: ' ',
                fontSize: 10,
            }, {
                text: ' ',
                fontSize: 10,
            }, {
                text: 'Purchase Order', 
                style: 'header',
            }, {
                text: 'PO # ' + po_num,
                style: 'header2'
            }, {
                text: ' ',
                fontSize: 10,
            }, {
                text: ' ',
                fontSize: 10,
            }, {
                text: 'To Supplier: ' + supplier_text,
                fontSize: 10,
            }]
        }

        var logo_section = {
            width: '*',
            stack: [{
                image: $scope.trade.reports_logo,
                width: 280,
            }]
        }

        var pdf_header = {
            fontSize: 10,
            columns: [
                po_section,
                logo_section
            ],
            margin : [ 0,0,0,10 ],
        }

        if($scope.selectedProject.project_address && 
            $scope.selectedProject.project_address.name &&
            $scope.selectedProject.project_address.name != '')
        {
            var left_box = [
                {
                    text: 'Job Details', 
                    style: 'header2a'
                },
                {
                    stack: [{
                        layout: {
                            hLineWidth: function hLineWidth(i) {return 0;},
                            vLineWidth: function vLineWidth(i) { return 0;},
                            paddingLeft: function(i, node) { return 0; },
                            paddingRight: function(i, node) { return 0; },
                            paddingTop: function(i, node) { return 0; },
                            paddingBottom: function(i, node) { return 0; }
                        },
                        table: {
                            headerRows: 0,
                            widths: [85, '*'],
                            body: [
                                [' ',' '],
                                ['Builder: ', $scope.builder],
                                ['Builder Number: ', $scope.selectedProject.trade_code + '-' + $scope.selectedProject.company_code],
                                ['Job: ', $scope.job_name],
                                ['Job Code: ', $scope.job_code],
                                ['Phase: ', $scope.selectedPhase.name],
                                ['Lots:', $scope.getLotText()],
                                ['Task:', $scope.selectedReport.task_code],
                                ['Task Start Date:', moment($scope.start_date).format('MMM D, YYYY : HH:mm')],
                                ['Delivery Date:', moment($scope.selectedReport.delivery_date).format('MMM D, YYYY : HH:mm')],
                                ['Project Address:', $scope.selectedProject.contact.address_one + ' '], //add blanks to avoid errors if empty
                                [' ', $scope.selectedProject.contact.city + ', ' + $scope.selectedProject.contact.state + ' ' + $scope.selectedProject.contact.zip],
                                ['Ship to:', $scope.selectedProject.project_address.name + ' '],
                                [' ', $scope.selectedProject.project_address.address + ' '],
                                [' ', $scope.selectedProject.project_address.city + ', ' + $scope.selectedProject.project_address.state + ' ' + $scope.selectedProject.project_address.zip],
                            ]
                        }
                    }]
                }
            ]
        } else {
            var left_box = [
                {
                    text: 'Job Details', 
                    style: 'header2a'
                },
                {
                    stack: [{
                        layout: {
                            hLineWidth: function hLineWidth(i) {return 0;},
                            vLineWidth: function vLineWidth(i) { return 0;},
                            paddingLeft: function(i, node) { return 0; },
                            paddingRight: function(i, node) { return 0; },
                            paddingTop: function(i, node) { return 0; },
                            paddingBottom: function(i, node) { return 0; }
                        },
                        table: {
                            headerRows: 0,
                            widths: [85, '*'],
                            body: [
                                [' ',' '],
                                ['Builder: ', $scope.builder],
                                ['Builder Number: ', $scope.selectedProject.trade_code + '-' + $scope.selectedProject.company_code],
                                ['Job: ', $scope.job_name],
                                ['Job Code: ', $scope.job_code],
                                ['Phase: ', $scope.selectedPhase.name],
                                ['Lots:', $scope.getLotText()],
                                ['Task:', $scope.selectedReport.task_code],
                                ['Task Start Date:', moment($scope.start_date).format('MMM D, YYYY : HH:mm')],
                                ['Delivery Date:', moment($scope.selectedReport.delivery_date).format('MMM D, YYYY : HH:mm')],
                                ['Project Address:', $scope.selectedProject.contact.address_one + ' '], //add blanks to avoid errors if empty
                                [' ', $scope.selectedProject.contact.city + ', ' + $scope.selectedProject.contact.state + ' ' + $scope.selectedProject.contact.zip],
                            ]
                        }
                    }]
                }
            ]
        }

        var right_box = [
            {
                text: 'Company Details', 
                style: 'header2a'
            },
            {
                stack: [{
                    layout: {
                        hLineWidth: function hLineWidth(i) {return 0;},
                        vLineWidth: function vLineWidth(i) { return 0;},
                        paddingLeft: function(i, node) { return 0; },
                        paddingRight: function(i, node) { return 0; },
                        paddingTop: function(i, node) { return 0; },
                        paddingBottom: function(i, node) { return 0; }
                    },
                    table: {
                        headerRows: 0,
                        widths: [110, '*'],
                        body: [
                            [' ',' '],
                            ['Company Name: ', $scope.trade.name],
                            ['Company Number: ', $scope.trade.phone],
                            ['Trade Manager Name: ', $scope.trade_manager],
                            ['Trade Manager Number: ', $scope.trade_manager_phone],
                            ['Foreman Name: ', $scope.foreman_info.name],
                            ['Foreman Number: ', $scope.foreman_info.phone],
                            ['Emailed to: ', $scope.getEmailText()],
                            [' ', ' '],
                            ['Submitted by: ', $scope.user.name],
                            ['Notes: ', ($scope.selectedReport.note && $scope.selectedReport.note != '')?$scope.selectedReport.note:'' + ' ']
                        ]
                    }
                }]
            }
        ]

        var pdf_boxes = {
            fontSize: 10,
            columns: [
                left_box,
                right_box
            ],
            margin : [ 0,0,0,10 ],
        }

		var test = {
            styles: {
                header: {
                    fontSize: 22,
                    bold: true,
                },
                header2: {
                    fontSize: 15,
                    margin:[0,0,0,-4],
                    bold: true,
                },
                header2a: {
                    fontSize: 15,
                    margin:[0,0,0,-2],
                    bold: true
                },
                anotherStyle: {
                    italics: true,
                    alignment: 'right'
                },
                squeezeSpacing: {
                    margin:[0,0,0,0]
                },
                lineSpacing: {
                    margin:[0,0,0,6] //change number 6 to increase nspace
                }
            },
			pageMargins: [ 10, 10, 10, 20 ],
		    pageSize: 'A4',
		    Roboto: {
				normal: 'Roboto-Regular.ttf',
				bold: 'Roboto-Medium.ttf',
				italics: 'Roboto-Italic.ttf',
				bolditalics: 'Roboto-Italic.ttf'
			},
			content: [
                pdf_header,
				pdf_boxes,
			    ' ',
			    {
			    	alignment: 'center',
			    	fontSize: 10,
			    	text: list_title, style: 'header'
			    },
                    ($scope.just_print)?($scope.is_foreman)?$scope.table(data, ['name', 'bid_note', 'foreman_note', 'color_code', 'lot', 'quantity']):$scope.table(data, ['name', 'bid_note', 'foreman_note', 'color_code', 'lot', 'quantity', 'price', 'sub_total']):
				        ($scope.is_foreman)?$scope.table(data, ['name', 'foreman_note', 'color_code', 'quantity']):$scope.table(data, ['name', 'foreman_note', 'color_code', 'quantity', 'price', 'sub_total']),
				    ' ',
				    ' ',
			    {
				    fontSize: 10,
					columns: [
						[

		          	 	]
			        ,
			          	[
							(!$scope.is_foreman)?'Subtotal:       $ ' + sub_total :'',
							(!$scope.is_foreman)?'Taxes:           $ ' + tax :'',
							(!$scope.is_foreman)?'Delivery:        $ ' + dev_price :'',
							(!$scope.is_foreman)?'Total:             $ ' + total :''
		          	 	]
			        ],
			        columnGap: 10
			    }
			],
            footer: function(currentPage, pageCount) {
                return {
                    margin: [10, 0, 10, 0],
                    height: 30,
                    columns: [{
                        text : 'Built using A.C.E. Construction Software',
                        width : 300,
                        //margin: [10,0,0,0]
                    }, {
                        width: '*',
                        text: '',
                    }, {
                        text: currentPage.toString() + ' of ' + pageCount,
                        alignment: 'right',
                        //margin: [0,0,10,0]
                    }]
                }
            },
				defaultStyle: {
			    	font: 'Roboto'
			}
		}

		var taskCode = $scope.selectedReport.task_code;
        var devDate = new moment($scope.selectedReport.delivery_date).format('MMM D, YYYY : HH:mm')

		var fileName = $scope.trade.name + '-' + $scope.selectedProject.name + '-' + $scope.selectedPhase.name +
				'-' + taskCode + '-' + rpt_num + '-PhaseReport.pdf';

        if($scope.just_print) {
    		pdfMake.createPdf(test).open();
            $scope.just_print = false;

            if($scope.print_as_foreman) {
                $scope.print_as_foreman = false;
                $scope.is_foreman = false;
            }
        } else {
            console.log('invoice submitted?', $scope.selectedReport);
            var projectInfo = angular.copy($scope.selectedReport);
            pdfMake.createPdf(test).getBase64(function(buffer) {
                var ship_to_addr = null;
                if($scope.selectedProject.project_address && 
                    $scope.selectedProject.project_address.name &&
                    $scope.selectedProject.project_address.name != '') {
                    ship_to_addr = '<br>Ship To Address: <br>' +
                        $scope.selectedProject.project_address.name + '<br>' +
                        $scope.selectedProject.project_address.address + '<br>' +
                        $scope.selectedProject.project_address.city + ', ' + $scope.selectedProject.project_address.state + ' ' +
                        $scope.selectedProject.project_address.zip;
                }
                var data = ({
                    to: $scope.email_contacts,
                    subject: $scope.trade.name + ' Order (' + po_num + ')',
                    message: 'Attached is an order from ' + $scope.trade.name + '<br>' +
                        '<strong>Delivery date is scheduled for ' + devDate +
                        '</strong> <br><br>' +
                        'Project Address: <br>' +
                        $scope.selectedProject.contact.address_one + '<br>' +
                        $scope.selectedProject.contact.city + ', ' + $scope.contact.state + ' ' +
                        $scope.selectedProject.contact.zip +
                        (ship_to_addr)?ship_to_addr:'' +
                        '<br><br><br>This report is created using .A.C.E. Construction Software.<br>' +
                        'Please reply all to this email to confirm receipt of this email.  If you have any questions, please contact the contractor.',
                    fileName: fileName,
                    attachment: buffer
                });

                $http.post('/api/sendPhaseReports', data).
                  success(function(data, status, headers, config) {
                    console.log('Message was successfully sent');
                  }).
                  error(function(data, status, headers, config) {
                    console.log('There was an error with the message');
                });

                // save to invoice into document
                var projectData = {
                    phase: projectInfo.phase,
                    project_id: projectInfo.project_id._id || projectInfo.project_id
                };
                projectData.fileName = po_num + '.pdf';
                projectData.folderTitle = 'Material & Equipment';
                projectData.uploadedBy = $scope.user.username;
                projectData.attachment = buffer;
                projectData.mainAccountId = $scope.main_account._id;
                $http.post('/api/materialReport', projectData).
                  success(function(data, status, headers, config) {
                    console.log('Report uploaded successfully');
                  }).
                  error(function(data, status, headers, config) {
                    console.log('There was an error with the message');
                });
            });
        }
	};

	$scope.consolidatedSubmitMaterials = function() {

		if($scope.is_manager && $scope.selectedReport.submitted) {
			if($scope.selectedReport.reviewed || $scope.selectedReport.reviewed === true) {
				alert('report has already been submitted for ' + $scope.selectedReport.task_name);
				return;
			}
		} else {
			if($scope.selectedReport.submitted || $scope.selectedReport.submitted === true) {
				alert('report has already been submitted for ' + $scope.selectedReport.task_name);
				return;
			}
        }

        // check material type and quantity
        var isInventory =  $scope.selectedReport.materials.filter(item => item.isInventory);
        var foundError = false;

        _.each(isInventory, function(mat) {
            var availableQty = 0;
            $scope.inventoryInvoice.forEach(item => {
                (item.material.name === mat.name) && (availableQty += (item.quantityLeft));
            });
            (availableQty < mat.quantity) && (foundError = true);
        });

        if(foundError) {
            toaster.pop('error', 'Qty Error', 'Order qauantity is not available in inventory. Contact Admin');
            return;
        } else if(isInventory.length) {
                // save/update into inventory invoices
                _.each(isInventory, function(mat) {
                    var totalsQty = JSON.parse(JSON.stringify(mat.quantity));

                    _.each($scope.inventoryInvoice, function(item, indexNo) {
                        var matItem = item.material;
                        (!Array.isArray(item.orderedMaterials)) && (item.orderedMaterials = []);
                        if (item.material.name === mat.name && totalsQty > 0) {
                            if((item.quantityLeft - totalsQty) >= 0) {
                                var ordQTY = JSON.parse(JSON.stringify(totalsQty));
                                var savingOrd  = ((matItem.price_per_order * ordQTY) - (matItem.bulkPrice * ordQTY));
                                item.quantityLeft = (item.quantityLeft - totalsQty);
                                var invoiceNo = $scope.selectedProject.trade_code + '-' +
                                    $scope.selectedReport.company_code + '-' + $scope.selectedReport.job_code + '-' +
                                    $scope.selectedReport.phase + '-' + $scope.selectedReport.task_code + '-' + (indexNo+1);
                                item.orderedMaterials.push({
                                    project_name: $scope.selectedProject.name,
                                    quantity: ordQTY,
                                    phase: $scope.selectedReport.phase,
                                    task_code: $scope.selectedReport.task_code,
                                    price_per_order: mat.price_per_order,
                                    invoice_number: invoiceNo,
                                    date_ordered: moment(),
                                    invoice_date: $scope.selectedReport.delivery_date,
                                    invoice_total: $scope.selectedReport.actual_total,
                                    date_dalivered: $scope.selectedReport.delivery_date,
                                    savings: !isNaN(savingOrd) ? (savingOrd) : 0
                                });
                                totalsQty = 0;
                                item.$update();
                            } else {
                                var qtyLeft = JSON.parse(JSON.stringify(item.quantityLeft));
                                var savingOrder  = ((matItem.price_per_order * qtyLeft) - (matItem.bulkPrice * qtyLeft));
                                var invoiceNo2 = $scope.selectedProject.trade_code + '-' +
                                    $scope.selectedReport.company_code + '-' + $scope.selectedReport.job_code + '-' +
                                    $scope.selectedReport.phase + '-' + $scope.selectedReport.task_code + '-' + (indexNo+1);
                                item.orderedMaterials.push({
                                    project_name: $scope.selectedProject.name,
                                    quantity: qtyLeft,
                                    phase: $scope.selectedReport.phase,
                                    task_code: $scope.selectedReport.task_code,
                                    price_per_order: mat.price_per_order,
                                    invoice_number: invoiceNo2,
                                    date_ordered: moment(),
                                    invoice_date: $scope.selectedReport.delivery_date,
                                    invoice_total: $scope.selectedReport.actual_total,
                                    date_dalivered: $scope.selectedReport.delivery_date,
                                    savings: !isNaN(savingOrder) ? savingOrder : 0
                                });
                                totalsQty = (totalsQty - item.quantityLeft);
                                item.quantityLeft = 0;
                                item.$update();
                            }
                        }
                    });
                })

                if($scope.is_manager) {
                    $scope.selectedReport.date_reviewed = moment();
                    $scope.selectedReport.reviewed = true;
                    $scope.selectedReport.date_submitted = moment();
                    $scope.selectedReport.submitted = true;
                } else {
                    $scope.selectedReport.date_submitted = moment();
                    $scope.selectedReport.submitted = true;
                }

                
                $scope.submittingReport = true;
                $scope.saveOrUpdateMaterial();
                $scope.showConsolidatedReport = false;
                $scope.showReport = false;
                $scope.showMatList = false;

        } else {

            if($scope.is_manager) {
                $scope.selectedReport.date_reviewed = moment();
                $scope.selectedReport.reviewed = true;
                $scope.selectedReport.date_submitted = moment();
                $scope.selectedReport.submitted = true;
            } else {
                $scope.selectedReport.date_submitted = moment();
                $scope.selectedReport.submitted = true;
            }

            $scope.submittingReport = true;
            $scope.saveOrUpdateMaterial();
            $scope.showConsolidatedReport = false;
            $scope.showReport = false;
            $scope.showMatList = false;

        }
	};

	$scope.consolidatedSubmitEquipment = function() {
		if($scope.is_manager && $scope.selectedReport.submitted) {
			if($scope.selectedReport.reviewed || $scope.selectedReport.reviewed === true) {
				alert('report has already been submitted for ' + $scope.selectedReport.task_name);
				return;
			}
		} else {
			if($scope.selectedReport.submitted || $scope.selectedReport.submitted === true) {
				alert('report has already been submitted for ' + $scope.selectedReport.task_name);
				return;
			}
		}

		if($scope.is_manager) {
			$scope.selectedReport.date_reviewed = moment();
			$scope.selectedReport.reviewed = true;
            $scope.selectedReport.date_submitted = moment();
            $scope.selectedReport.submitted = true;
		} else {
			$scope.selectedReport.date_submitted = moment();
			$scope.selectedReport.submitted = true;
		}
		$scope.submittingReport = true;

		$scope.saveOrUpdateEquipment();

		$scope.showConsolidatedReport = false;
		$scope.showReport = false;
		$scope.showMatList = false;
	};

    $scope.updateQuantityValues = function(item, e, unused) {
        e.stopPropagation();

        var total = 0;

        item.materials =
            foremanPhaseService.removeZeroQuantityItems(
                item.materials);

        item.materials =
            foremanPhaseService.combineSimilarItems(
                item.materials);

        var consolidated_list =
            foremanPhaseService.consolidateOnForemanNotes(
                item.materials, $scope.companyFactors.sales_tax, false);

        total = item.actual_total =
            foremanPhaseService.getConsolidatedActualTotal(
                consolidated_list, $scope.companyFactors.sales_tax);

        foremanAdjustCombinedQuantitiesService.setQuantityValues(
            consolidated_list,
            item.materials,
            $scope.companyFactors.sales_tax);

        item.quantities_corrected = true;

        $scope.savedBidTotal = item.bid_total;

        item.$update(function(response) {
            $scope.updateDate(response);
            item.delivery_date = moment(response.delivery_date);
            item.actual_total = total;
            item.bid_total = $scope.savedBidTotal;
            toaster.pop('success', 'Phase Report', 'Database updated.');
        }, function(error) {
            toaster.pop('error', 'Phase Report Error', error);
        });
    };

    $scope.updateDate = function(item) {
        item.delivery_date = moment.utc(item.delivery_date).format('MMM D, YYYY : HH:mm');
        item.report_date = moment.utc(item.report_date).format('MMM D, YYYY : HH:mm');
        item.start_date = moment.utc(item.start_date).format('MMM D, YYYY : HH:mm');
        //item.delivery_date = moment(item.delivery_date); //, 'MMM D, YYYY : HH:mm');
        //item.report_date = moment(item.report_date); //, 'MMM D, YYYY : HH:mm');
        //item.start_date = moment(item.start_date); //, 'MMM D, YYYY : HH:mm');
    };

	$scope.saveOrUpdateMaterial = function(spinner_type) {
        var total = 0;

        var materials =
            foremanPhaseService.removeZeroQuantityItems(
                $scope.selectedReport.materials);

        materials =
            foremanPhaseService.combineSimilarItems(materials);

        var consolidated_list =
            foremanPhaseService.consolidateOnForemanNotes(
                materials, $scope.companyFactors.sales_tax, false);

        $scope.selectedReport.bid_total =
            foremanPhaseService.getConsolidatedBidTotal(
                consolidated_list, $scope.companyFactors.sales_tax);

        total = $scope.selectedReport.actual_total =
            foremanPhaseService.getConsolidatedActualTotal(
                consolidated_list, $scope.companyFactors.sales_tax);

        $scope.selectedReport.quantities_corrected = true;

        $scope.savedBidTotal = $scope.selectedReport.bid_total;
          
        if(!$scope.selectedReport.userId) {
            $scope.selectedReport.userId = $scope.main_account._id;
        }
		if($scope.selectedReport._id) {
            // I'm leaving this here for now.  It was put here and used
            // to work but now it's causing negative quantities and removing
            // it makes everything good.  Leaving just in case there is
            // an edge case I'm not seeing now 7/13/20
            if($scope.selectedReport.reviewed) {
                foremanAdjustCombinedQuantitiesService.setQuantityValues(
                    $scope.consolidated_materials_list,
                    $scope.selectedReport.materials,
                    $scope.companyFactors.sales_tax);
                $scope.buildPDF(consolidated_list);
            }

            $scope.selectedReport.invoice_date = $scope.selectedReport.delivery_date;
            $scope.selectedReport.invoice_total = $scope.selectedReport.actual_total.toFixed(2);

			$scope.selectedReport.$update(function(response) {
                $scope.updateDate(response);
                $scope.selectedReport.delivery_date = moment(response.delivery_date);
                $scope.selectedReport.invoice_date = moment(response.invoice_date);
                $scope.selectedReport.actual_total = total;
                $scope.selectedReport.bid_total = $scope.savedBidTotal;
                $scope.getReportMaterialTotals();
				if($scope.submittingReport) {
                    var record = new ProjectMaterialSnapshots({
                        project_material_id: response._id,
                        materials: response.materials
                    });

                    record.$save(function(success) {
                        console.log('saved snapshot');
                    }, function(error) {
                        toaster.pop('error', 'Problem Saving Snapshot', error);
                    });
					$scope.changePhase($scope.selectedPhase);
					$scope.submittingReport = false;
				}

                if(spinner_type) {
                    $loading.finish(spinner_type);
                }
			});
		} else {
            ProjectMaterials.query({
                'project_id': $scope.selectedProject._id,
                'complete': false,
                'phase': $scope.selectedReport.phase,
                'task_code': $scope.selectedReport.task_code,
                'submitted': true  }, function(projMatsDB) {

                $scope.selectedReport.sub_report_number = projMatsDB.length;

                if($scope.selectedReport.reviewed) {
                    foremanAdjustCombinedQuantitiesService.setQuantityValues(
                        $scope.consolidated_materials_list,
                        $scope.selectedReport.materials,
                        $scope.companyFactors.sales_tax);
                    $scope.buildPDF(consolidated_list);
                }

                $scope.selectedReport.invoice_date = $scope.selectedReport.delivery_date;
                $scope.selectedReport.invoice_total = $scope.selectedReport.actual_total.toFixed(2);

    			$scope.selectedReport.$save(function(response) {
                    $scope.updateDate(response);
                    $scope.selectedReport.delivery_date = moment(response.delivery_date);
                    $scope.selectedReport.invoice_date = moment(response.invoice_date);
                    $scope.selectedReport.actual_total = total;
                    $scope.selectedReport.bid_total = $scope.savedBidTotal;
    				$scope.materialdb.push($scope.selectedReport);
                    $scope.getReportMaterialTotals();
    				if($scope.submittingReport) {
                        var record = new ProjectMaterialSnapshots({
                            project_material_id: response._id,
                            materials: response.materials
                        });

                        record.$save(function(success) {
                            console.log('saved snapshot');
                        }, function(error) {
                            toaster.pop('error', 'Problem Saving Snapshot', error);
                        });
    					$scope.changePhase($scope.selectedPhase);
    					$scope.submittingReport = false;
    				}

                    if(spinner_type) {
                        $loading.finish(spinner_type);
                    }
    			});
            });
		}
	};

	$scope.saveOrUpdateEquipment = function() {
		var total = 0;

		//make sure each item has the correct numbers and
		//add up the totals for the view
		_.each($scope.selectedReport.equipment, function(item) {
			item.sub_total = item.quantity * item.price_per_order;
			item.total = item.sub_total + ($scope.companyFactors.equipment_tax * item.sub_total) +
					(item.delivery_price * item.quantity);
			total += item.total;
		});

        $scope.selectedReport.equipment =
            foremanPhaseService.removeZeroQuantityItems(
                $scope.selectedReport.equipment);

        $scope.selectedReport.equipment =
            foremanPhaseService.combineSimilarItems(
                $scope.selectedReport.equipment);

        var consolidated_list =
            foremanPhaseService.consolidateEquipmentOnForemanNotes(
                $scope.selectedReport.equipment, $scope.companyFactors.equipment_tax);

        $scope.selectedReport.bid_total =
            foremanPhaseService.getConsolidatedEquipmentBidTotal(
                consolidated_list, $scope.companyFactors.equipment_tax);

        total = $scope.selectedReport.actual_total =
            foremanPhaseService.getConsolidatedEquipmentActualTotal(
                consolidated_list, $scope.companyFactors.equipment_tax);

        if($scope.selectedReport.reviewed)
          $scope.buildPDF(consolidated_list);

        $scope.selectedReport.quantities_corrected = true;

        if(!$scope.selectedReport.userId) {
            $scope.selectedReport.userId = $scope.main_account._id;
        }

		//have to save the bid total here so we can reset it in the response
		$scope.savedBidTotal = $scope.selectedReport.bid_total;
		if($scope.selectedReport._id) {
            _.each(consolidated_list, function(item) {
                $scope.adjustEquipmentQuantityValues(item, $scope.companyFactors.equipment_tax);
            });

			$scope.selectedReport.$update(function(response) {
                $scope.updateDate(response);
                $scope.selectedReport.delivery_date = moment(response.delivery_date);
                $scope.selectedReport.invoice_date = moment(response.invoice_date);
                $scope.selectedReport.actual_total = total;
                $scope.selectedReport.bid_total = $scope.savedBidTotal;
                $scope.getReportEquipmentTotals();
				if($scope.submittingReport) {
					$scope.changePhase($scope.selectedPhase);
					$scope.submittingReport = false;
				}
			});
		} else {
            ProjectEquipments.query({
                'project_id': $scope.selectedProject._id,
                'complete': false,
                'phase': $scope.selectedReport.phase,
                'task_code': $scope.selectedReport.task_code }, function(projMatsDB) {

                // foremanAdjustCombinedQuantitiesService.setQuantityValues(
                //     $scope.consolidated_equipment_list,
                //     $scope.selectedReport.equipment,
                //     $scope.companyFactors.equipment_tax);

                $scope.selectedReport.sub_report_number = projMatsDB.length;

                $scope.selectedReport.invoice_date = $scope.selectedReport.delivery_date;
                $scope.selectedReport.invoice_total = $scope.selectedReport.actual_total;

    			$scope.selectedReport.$save(function(response) {
                    $scope.updateDate(response);
                    $scope.selectedReport.delivery_date = moment(response.delivery_date);
                    $scope.selectedReport.invoice_date = moment(response.invoice_date);
                    $scope.selectedReport.actual_total = total;
                    $scope.selectedReport.bid_total = $scope.savedBidTotal;
    				$scope.equipmentdb.push($scope.selectedReport);
                    $scope.getReportEquipmentTotals();
    				if($scope.submittingReport) {
    					$scope.changePhase($scope.selectedPhase);
    					$scope.submittingReport = false;
    				}
    			});
            });
		}
	};

	$scope.consolidatedBack = function() {
		$scope.showConsolidatedReport = false;
		$scope.showReport = true;
		$scope.showMatList = false;
	};

	$scope.editItem = function (item) {
		if(item.editing) return;
        item.editing = true;
    };

    $scope.donePriceEditing = function (item) {
        if(!item.editing) return;

        item.price_per_order = Math.abs(item.price_per_order);

        var materials = $filter('filter')($scope.selectedReport.materials, {'name': item.name}, true);

        _.each(materials, function(material) {
            material.price_per_order = item.price_per_order
        });

        $scope.saveOrUpdateMaterial();
        item.editing = false;
    };

    $scope.doneEditing = function (item) {
    	if(!item.editing) return;

        $loading.start('edit-quantity');

        item.quantity = Math.abs(item.quantity);

        //$scope.adjustMaterialQuantityValues(item, $scope.companyFactors.sales_tax);
        $scope.saveOrUpdateMaterial('edit-quantity');
        item.editing = false;

  //       if(item._id) {
  //       	var update = $filter('filter')($scope.selectedReport.materials, {'_id': item._id}, true);
  //       } else {
  //       	var update = $filter('filter')($scope.selectedReport.materials, {
  //       		'name': item.name, 'lot': item.lot, 'plan_code': item.plan_code,
  //               'bid_quantity': item.bid_quantity}, true);
  //       }
  //   	if(update.length !== 1) {
  //   		alert('Could not get the item from the report list for updating.  Contact Admin.');
  //   		return;
  //   	}
  //   	update[0].quantity = item.quantity;
  //   	update[0].sub_total = item.sub_total;
  //   	update[0].sales_tax = item.sales_tax;
  //   	update[0].total = item.total;
		// if($scope.selectedReport._id) {
  //           $scope.selectedReport.$update(function(response) {
  //               $scope.updateDate(response);
  //               $scope.selectedReport.delivery_date = moment(response.delivery_date);
  //               $scope.getReportMaterialTotals();
  //           });
  //       } else {
  //           ProjectMaterials.query({
  //               'project_id': $scope.selectedProject._id,
  //               'complete': false,
  //               'phase': $scope.selectedReport.phase,
  //               'task_code': $scope.selectedReport.task_code,
  //               'submitted': true  }, function(projMatsDB) {

  //               $scope.selectedReport.sub_report_number = projMatsDB.length;

  //               $scope.selectedReport.$save(function(response) {
  //                   $scope.updateDate(response);
  //                   $scope.selectedReport.delivery_date = moment(response.delivery_date);
  //                   $scope.materialdb.push($scope.selectedReport);
  //                   $scope.getReportMaterialTotals();
  //               });
  //           });
  //       }
    };

    $scope.doneEQEditing = function (item) {
        if(!item.editing) return;

        item.quantity = Math.abs(item.quantity);

        $scope.adjustEquipmentQuantityValues(item, $scope.companyFactors.equipment_tax);

        item.editing = false;

        if(item._id) {
            var update = $filter('filter')($scope.selectedReport.equipment, {
                '_id': item._id}, true);
        } else {
            var update = $filter('filter')($scope.selectedReport.equipment, {
                'name': item.name, 'lot': item.lot, 'plan_code': item.plan_code}, true);
        }
        if(update.length !== 1) {
            alert('Could not get the item from the report list for updating.  Contact Admin.');
            return;
        }
        update[0].quantity = item.quantity;
        update[0].sub_total = item.sub_total;
        update[0].equipment_tax = item.equipment_tax;
        update[0].total = item.total;
        $scope.saveOrUpdateEquipment();
    };

    $scope.doneEditingForemanNote = function(item) {
    	if($scope.selectedReport.materials && $scope.selectedReport.materials.length > 0) {
    		//we need to update/save the current material item.  First see if it has been saved
            $scope.saveOrUpdateMaterial();
    		// if(item._id) {
	    	// 	var in_list = $filter('filter')($scope.selectedReport.materials, {
      //               '_id': item._id}, true);
	    	// 	if(in_list.length === 1) {
	    	// 		in_list[0].foreman_note = (item.foreman_note)?item.foreman_note:'';
	    	// 		// $scope.saveOrUpdateMaterial();
      //               // if($scope.selectedReport._id) {
      //               //     $scope.selectedReport.$update(function(response) {
      //               //         $scope.updateDate(response);
      //               //         $scope.selectedReport.delivery_date = moment(response.delivery_date);
      //               //         $scope.getReportMaterialTotals();
      //               //     });
      //               // } else {
      //               //     ProjectMaterials.query({
      //               //         'project_id': $scope.selectedProject._id,
      //               //         'complete': false,
      //               //         'phase': $scope.selectedReport.phase,
      //               //         'task_code': $scope.selectedReport.task_code,
      //               //         'submitted': true  }, function(projMatsDB) {

      //               //         $scope.selectedReport.sub_report_number = projMatsDB.length;
      //               //         $scope.adjustMaterialQuantityValues(item, $scope.companyFactors.sales_tax);

      //               //         $scope.selectedReport.$save(function(response) {
      //               //             $scope.updateDate(response);
      //               //             $scope.selectedReport.delivery_date = moment(response.delivery_date);
      //               //             $scope.materialdb.push($scope.selectedReport);
      //               //             $scope.getReportMaterialTotals();
      //               //         });
      //               //     });
      //               // }
	    	// 	}
	    	// } else {
	    	// 	//the item has not been saved so lets find it by other key items
	    	// 	var in_list = $filter('filter')($scope.selectedReport.materials, {
      //               'name': item.name,
	    	// 				'plan_code': item.plan_code, 'lot': item.lot }, true);
      //           $scope.adjustMaterialQuantityValues(item, $scope.companyFactors.sales_tax);
	    	// 	if(in_list.length === 1) {
	    	// 		in_list[0].foreman_note = (item.foreman_note)?item.foreman_note:'';
	    	// 		if($scope.selectedReport._id) {
      //                   $scope.selectedReport.$update(function(response) {
      //                       $scope.updateDate(response);
      //                       $scope.selectedReport.delivery_date = moment(response.delivery_date);
      //                       $scope.getReportMaterialTotals();
      //                   });
      //               } else {
      //                   ProjectMaterials.query({
      //                       'project_id': $scope.selectedProject._id,
      //                       'complete': false,
      //                       'phase': $scope.selectedReport.phase,
      //                       'task_code': $scope.selectedReport.task_code,
      //                       'submitted': true  }, function(projMatsDB) {
      //                       $scope.selectedReport.sub_report_number = projMatsDB.length;

      //                       $scope.selectedReport.$save(function(response) {
      //                           $scope.updateDate(response);
      //                           $scope.selectedReport.delivery_date = moment(response.delivery_date);
      //                           $scope.materialdb.push($scope.selectedReport);
      //                           $scope.getReportMaterialTotals();
      //                       });
      //                   });
      //               }
	    	// 	}
	    	// }
    	} else if($scope.selectedReport.equipment && $scope.selectedReport.equipment.length > 0) {
    		//we need to update/save the current material item.  First see if it has been saved
    		if(item._id) {
	    		var in_list = $filter('filter')($scope.selectedReport.equipment, {
                    '_id': item._id}, true);
	    		if(in_list.length === 1) {
	    			in_list[0].foreman_note = (item.foreman_note)?item.foreman_note:'';
		    		$scope.saveOrUpdateEquipment();
		    	}
		    } else {
		    	//the item has not been saved so lets find it by other key items
		    	var in_list = $filter('filter')($scope.selectedReport.equipment, {
                    'name': item.name,
	    					'plan_code': item.plan_code, 'lot': item.lot }, true);
	    		if(in_list.length === 1) {
	    			in_list[0].foreman_note = (item.foreman_note)?item.foreman_note:'';
	    			$scope.saveOrUpdateEquipment();
	    		}
	    	}
    	} else {
    		alert('Could not determine report type for saving.  Contact Admin.');
    		return;
    	}
    };

    $scope.editingFormanNoteConsolidated = function (item) {
    	//we need to store the foreman note so we can search on that value
    	//when done editing
    	$scope.currentForemanNote = (item.foreman_note)?item.foreman_note:'';
    };

    $scope.doneEditingForemanNoteConsolidated = function (item) {
        item.foreman_note = (item.foreman_note)?item.foreman_note:'';
        if($scope.selectedReport.materials && $scope.selectedReport.materials.length > 0) {
    		//grab all the material entries and update the foreman notes
    		var in_list = $filter('filter')($scope.selectedReport.materials, {
                'name': item.name, 'color_code': item.color_code,
    			'foreman_note': $scope.currentForemanNote}, true);
            
    		_.each(in_list, function(li) {
                for(var i=0; i<item.lots.length; i++) {
                    if(item.lots[i].name === li.lot) {
                        li.foreman_note = item.foreman_note;
                        break;
                    }
                }
    		});

    		$scope.savedBidTotal = $scope.selectedReport.bid_total;

            $scope.saveOrUpdateMaterial();
            // if($scope.selectedReport._id) {
            //     $scope.selectedReport.$update(function(response) {
            //         $scope.updateDate(response);
            //         $scope.selectedReport.delivery_date = moment(response.delivery_date);
            //         $scope.selectedReport.bid_total = $scope.savedBidTotal;
            //         $scope.getReportMaterialTotals();
            //     });
            // } else {
            //     ProjectMaterials.query({
            //         'project_id': $scope.selectedProject._id,
            //         'complete': false,
            //         'phase': $scope.selectedReport.phase,
            //         'task_code': $scope.selectedReport.task_code,
            //         'submitted': true  }, function(projMatsDB) {

            //         $scope.selectedReport.sub_report_number = projMatsDB.length;
            //         $scope.adjustMaterialQuantityValues(item, $scope.companyFactors.sales_tax);
            //         $scope.selectedReport.$save(function(response) {
            //             $scope.updateDate(response);
            //             $scope.selectedReport.delivery_date = moment(response.delivery_date);
            //             $scope.selectedReport.bid_total = $scope.savedBidTotal;
            //             $scope.materialdb.push($scope.selectedReport);
            //             $scope.getReportMaterialTotals();
            //         });
            //     });
            // }
    	} else if($scope.selectedReport.equipment && $scope.selectedReport.equipment.length > 0) {

	    	//the item has not been saved so lets find it by other key items
	    	var in_list = $filter('filter')($scope.selectedReport.equipment, {'name': item.name,
    					'foreman_note': $scope.currentForemanNote}, true);
    		_.each(in_list, function(li) {
                for(var i=0; i<item.lots.length; i++) {
                    if(item.lots[i].name === li.lot) {
                        li.foreman_note = item.foreman_note;
                        break;
                    }
                }
            });

			$scope.savedBidTotal = $scope.selectedReport.bid_total;
            $scope.adjustEquipmentQuantityValues(item, $scope.companyFactors.equipment_tax);

            if($scope.selectedReport._id) {
                $scope.selectedReport.$update(function(response) {
                    $scope.updateDate(response);
                    $scope.selectedReport.delivery_date = moment(response.delivery_date);
                    $scope.selectedReport.bid_total = $scope.savedBidTotal;
                    $scope.getReportMaterialTotals();
                    if($scope.submittingReport) {
                        $scope.changePhase($scope.selectedPhase);
                        $scope.submittingReport = false;
                    }
                });
            } else {
                ProjectEquipments.query({
                    'project_id': $scope.selectedProject._id,
                    'complete': false,
                    'phase': $scope.selectedReport.phase,
                    'task_code': $scope.selectedReport.task_code }, function(projMatsDB) {

                    $scope.selectedReport.sub_report_number = projMatsDB.length;

                    $scope.selectedReport.$save(function(response) {
                        $scope.updateDate(response);
                        $scope.selectedReport.delivery_date = moment(response.delivery_date);
                        $scope.selectedReport.bid_total = $scope.savedBidTotal;
                        $scope.materialdb.push($scope.selectedReport);
                        $scope.getReportMaterialTotals();
                        if($scope.submittingReport) {
                            $scope.changePhase($scope.selectedPhase);
                            $scope.submittingReport = false;
                        }
                    });
                });
            }
    	} else {
    		alert('Could not determine report type for saving.  Contact Admin.');
    		return;
    	}

    	$scope.currentForemanNote = '';
    };

    $scope.editQuantity = function (item) {
    	if(item.quantityEditing) return;
    	item.quantity = Math.abs(item.quantity);
    	$scope.originalQuantity = item.quantity;
    	$scope.originalNote = item.foreman_note;
        item.quantityEditing = true;
    };

    $scope.adjustMaterialQuantityValues = function(item, tax) {
        var list = [];

        item.total = item.quantity * item.price_per_order;

        //need to adjust the originial list items from $scope.materials_list
        list = $filter('filter')($scope.selectedReport.materials, {
                    'foreman_note': (item.foreman_note)?item.foreman_note:'',
                    'color_code': (item.color_code)?item.color_code:'',
                    'name': item.name}, true);

        var items_total = 0;
        //need to do a weighted average of all similar items
        //first add up all the items in the list
        _.each(list, function(listItem) {
            items_total += listItem.quantity;
        });

        item.sub_total = 0;
        if(items_total) {
            var factor = item.quantity / items_total;
        } else {
            var factor = item.quantity / list.length;
        }

        //now apply the factor back to the list items
        _.each(list, function(listItem) {
            if(listItem.quantity)
              listItem.quantity *= factor;
            else
              listItem.quantity = factor;

            item.sub_total += listItem.quantity * listItem.price_per_order;
        });

        //update values in the view
        item.sales_tax = item.sub_total * tax;
        item.total = item.sub_total + item.sales_tax + (item.delivery_price * item.quantity);
    };

    $scope.doneEditingMaterialQuantity = function (item) {
        if(!item.quantityEditing) return;

        item.quantity = Math.abs(item.quantity);
        
        if(Number(item.quantity.toFixed(8)) % 1 !== 0) {
        	item.quantity = $window.Math.floor(item.quantity);
        }

        $loading.start('edit-quantity');

        $scope.adjustMaterialQuantityValues(item, $scope.companyFactors.sales_tax);

        $scope.saveOrUpdateMaterial('edit-quantity');

        item.quantityEditing = false;
  //       var consolidated_list =
  //           foremanPhaseService.consolidateOnForemanNotes(
  //               $scope.selectedReport.materials, $scope.companyFactors.sales_tax, false);

  //       $scope.selectedReport.bid_total =
  //           foremanPhaseService.getConsolidatedBidTotal(
  //               consolidated_list, $scope.companyFactors.sales_tax);

  //       var total = $scope.selectedReport.actual_total =
  //           foremanPhaseService.getConsolidatedActualTotal(
  //               consolidated_list, $scope.companyFactors.sales_tax);

		// //$scope.saveOrUpdateMaterial();
  //       $scope.savedBidTotal = $scope.selectedReport.bid_total;

  //       if($scope.selectedReport._id) {
  //           $scope.selectedReport.$update(function(response) {
  //               $scope.updateDate(response);
  //               $scope.selectedReport.delivery_date = moment(response.delivery_date);
  //               $scope.selectedReport.actual_total = total;
  //               $scope.selectedReport.bid_total = $scope.savedBidTotal;
  //               $scope.getReportMaterialTotals();
  //           });
  //       } else {
  //           ProjectMaterials.query({
  //               'project_id': $scope.selectedProject._id,
  //               'complete': false,
  //               'phase': $scope.selectedReport.phase,
  //               'task_code': $scope.selectedReport.task_code,
  //               'submitted': true  }, function(projMatsDB) {

  //               $scope.selectedReport.sub_report_number = projMatsDB.length;
  //               $scope.selectedReport.$save(function(response) {
  //                   $scope.updateDate(response);
  //                   $scope.selectedReport.actual_total = total;
  //                   $scope.selectedReport.bid_total = $scope.savedBidTotal;
  //                   $scope.materialdb.push($scope.selectedReport);
  //                   $scope.getReportMaterialTotals();
  //               });
  //           });
  //       }
    };

    // $scope.editMaterialQuantity = function (item) {
    //     if(!item.quantityEditing) return;

    //     item.quantity = Math.abs(item.quantity);

    //     if(item.quantity % 1 !== 0) {
    //     	item.quantity = $window.Math.floor(item.quantity);
    //     }

    //     var list = [];

    //     item.total = item.quantity * item.price_per_order;

    //     //need to adjust the originial list items from $scope.materials_list
    //     list = $filter('filter')($scope.selectedReport.materials, {
    //     			'foreman_note': item.foreman_note,
    //     			'name': item.name}, true);

    //     var items_total = 0;
    //     //need to do a weighted average of all similar items
    //     //first add up all the items in the list
    //     _.each(list, function(listItem) {
    //     	items_total += listItem.quantity;
    //     });

    //     item.sub_total = 0;
    //     if(items_total) {
    //     	var factor = item.quantity / items_total;
    //     } else {
    //     	var factor = item.quantity / list.length;
    //     }

    // 	//now apply the factor back to the list items
    //     _.each(list, function(listItem) {
    //     	if(listItem.quantity)
    //     	  listItem.quantity *= factor;
    //         else
    //           listItem.quantity = factor;

    // 	    item.sub_total += listItem.quantity * listItem.price_per_order;
    //     });

    //     //update values in the view
    //     item.sales_tax = item.sub_total * $scope.companyFactors.sales_tax;
    //     item.total = item.sub_total + item.sales_tax + (item.delivery_price * item.quantity);

    //     item.quantityEditing = false;
    // };

    $scope.adjustEquipmentQuantityValues = function(item, tax) {
        var list = [];

        item.total = item.quantity * item.price_per_order;

        //need to adjust the originial list items from $scope.materials_list
        list = $filter('filter')($scope.selectedReport.equipment, {
                    'foreman_note': (item.foreman_note)?item.foreman_note:'',
                    'name': item.name}, true);

        var items_total = 0;
        //need to do a weighted average of all similar items
        //first add up all the items in the list
        _.each(list, function(listItem) {
            items_total += listItem.quantity;
        });

        item.sub_total = 0;
        if(items_total) {
            var factor = item.quantity / items_total;
        } else {
            var factor = item.quantity / list.length;
        }

        //now apply the factor back to the list items
        _.each(list, function(listItem) {
            if(listItem.quantity)
              listItem.quantity *= factor;
            else
              listItem.quantity = factor;

            item.sub_total += listItem.quantity * listItem.price_per_order;
        });

        //update values in the view
        item.sales_tax = item.sub_total * tax;
        item.total = item.sub_total + item.sales_tax + (item.delivery_price * item.quantity);
    };

    $scope.doneEditingEquipmentQuantity = function (item) {
        if(!item.quantityEditing) return;

        item.quantity = Math.abs(item.quantity);

        if(Number(item.quantity.toFixed(8)) % 1 !== 0) {
        	item.quantity = $window.Math.floor(item.quantity);
        }

        $scope.adjustEquipmentQuantityValues(item, $scope.companyFactors.equipment_tax);

        item.quantityEditing = false;

		var consolidated_list =
            foremanPhaseService.consolidateOnForemanNotes(
                $scope.selectedReport.equipment, $scope.companyFactors.equipment_tax, false);

        $scope.selectedReport.bid_total =
            foremanPhaseService.getConsolidatedBidTotal(
                consolidated_list, $scope.companyFactors.equipment_tax);

        var total = $scope.selectedReport.actual_total =
            foremanPhaseService.getConsolidatedActualTotal(
                consolidated_list, $scope.companyFactors.equipment_tax);

        //$scope.saveOrUpdateMaterial();
        $scope.savedBidTotal = $scope.selectedReport.bid_total;

        if($scope.selectedReport._id) {
            $scope.selectedReport.$update(function(response) {
                $scope.updateDate(response);
                $scope.selectedReport.delivery_date = moment(response.delivery_date);
                $scope.selectedReport.actual_total = total;
                $scope.selectedReport.bid_total = $scope.savedBidTotal;
                $scope.getReportEquipmentTotals();
            });
        } else {
            ProjectEquipments.query({
                'project_id': $scope.selectedProject._id,
                'complete': false,
                'phase': $scope.selectedReport.phase,
                'task_code': $scope.selectedReport.task_code }, function(projMatsDB) {
                $scope.selectedReport.sub_report_number = projMatsDB.length;
                $scope.selectedReport.$save(function(response) {
                    $scope.updateDate(response);
                    $scope.selectedReport.delivery_date = moment(response.delivery_date);
                    $scope.selectedReport.actual_total = total;
                    $scope.selectedReport.bid_total = $scope.savedBidTotal;
                    $scope.materialdb.push($scope.selectedReport);
                    $scope.getReportEquipmentTotals();
                });
            });
        }
    };

    $scope.editEquipmentQuantity = function (item) {
        if(!item.quantityEditing) return;

        item.quantity = Math.abs(item.quantity);

        if(Number(item.quantity.toFixed(8)) % 1 !== 0) {
        	item.quantity = $window.Math.floor(item.quantity);
        }

        var list = [];

    	item.total = item.quantity * item.price_per_order;

        //need to adjust the originial list items from $scope.materials_list
        list = $filter('filter')($scope.selectedReport.equipment, {
        			'foreman_note': (item.foreman_note)?item.foreman_note:'',
        			'name': item.name}, true);

        var items_total = 0;
        //need to do a weighted average of all similar items
        //first add up all the items in the list
        _.each(list, function(listItem) {
        	items_total += listItem.quantity;
        });

        item.sub_total = 0;
        if(items_total) {
        	var factor = item.quantity / items_total;
        } else {
        	var factor = item.quantity / list.length;
        }

        //now apply the factor back to the list items
        _.each(list, function(listItem) {
        	if(listItem.quantity)
        	  listItem.quantity *= factor;
            else
              listItem.quantity = factor;
        	item.sub_total += listItem.quantity * listItem.price_per_order;
        });

        //update values in the view
        item.equipment_tax = item.sub_total * $scope.companyFactors.equipment_tax;
        item.total = item.sub_total + item.equipment_tax + (item.delivery_price * item.quantity);

        item.quantityEditing = false;
    };

    $scope.open = function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        $scope.opened = true;
    };

    $scope.supplierModalActivated = function() {
        if(!$scope.available_suppliers) {
            $scope.available_suppliers = [];
            $scope.all_materials = [];

            // $scope.available_suppliers.push({
            //     name: $scope.selectedReport.supplier
            // });

            Materials.query({
                'trade_account': $scope.trade._id ,
                'supplier': $scope.selectedReport.supplier,
                'userId': $scope.main_account._id
            }, function(materials) {

                $scope.all_materials = materials;

                $scope.all_materials = $filter('orderBy')($scope.all_materials, 'name');
                $scope.overridden_categories = [];

                _.each($scope.all_materials, function(material) {
                    var in_list = $filter('filter')($scope.overridden_categories, {
                        'name': material.category}, true);
                    if(in_list.length === 0) {
                        $scope.overridden_categories.push({
                            name: material.category
                        });
                    }
                });
            });
        }
    };

    $scope.supplierEquipmentModalActivated = function() {
        if(!$scope.available_eq_suppliers) {
            $scope.available_eq_suppliers = [];

            $scope.available_eq_suppliers.push({
                name: $scope.selectedReport.supplier
            });

            Equipments.query({ 'trade_account': $scope.trade._id,
            	'supplier': $scope.selectedReport.supplier}, function(equipments) {
                $scope.all_equipments = equipments;
            });
        }
    };

    $scope.onSupplierSelect = function() {
        if(!this.new_supplier) return;

        $scope.overridden_materials = $filter('filter')($scope.all_materials, {
            'supplier': this.new_supplier.name }, true);
        $scope.overridden_materials = $filter('orderBy')($scope.overridden_materials, 'name');
        $scope.overridden_categories = [];

        _.each($scope.overridden_materials, function(material) {
            var in_list = $filter('filter')($scope.overridden_categories, {
                'name': material.category}, true);
            if(in_list.length === 0) {
                $scope.overridden_categories.push({
                    name: material.category
                });
            }
        });
    };

    $scope.onEquipmentSupplierSelect = function() {
        $scope.overridden_equipments = $filter('filter')($scope.all_equipments, {
            'supplier': this.new_supplier.name }, true);
        $scope.overridden_equipment_categories = [];

        _.each($scope.overridden_materials, function(equipment) {
            var in_list = $filter('filter')($scope.overridden_equipment_categories, {
                'name': equipment.category}, true);
            if(in_list.length === 0) {
                $scope.overridden_equipment_categories.push({
                    name: equipment.category
                });
            }
        });
    };

    $scope.addMaterial = function(new_material) {
        if(!new_material.all && !new_material.lot) {
            toaster.pop('error', 'Lot Selectiong', 'You must select a lot');
            return;
        }

        console.log(this);
    	if(!new_material.delivery_price) new_material.delivery_price = 0;
        var lots = [];
        if(new_material.all) {
            lots = $filter('filter')($scope.selectedProject.lots, {
                'phase': $scope.selectedPhase.name }, true);
        } else {
            if(angular.isArray(new_material.lot)) {
                _.each(new_material.lot, function(lot) {
                    var add_lot = $filter('filter')($scope.selectedProject.lots, {
                        'number': lot,
                        'phase': $scope.selectedPhase.name }, true);

                    if(add_lot.length == 1) {
                        lots.push(add_lot[0])
                    } else {
                        toaster.pop('error', 'Problem Adding Lot ' + lot,
                            'Could not find the requested lot in the projects lot list');
                    }
                });
            } else {
                var add_lot = $filter('filter')($scope.selectedProject.lots, {
                    'number': new_material.lot.item,
                    'phase': $scope.selectedPhase.name }, true);

                if(add_lot.length == 1) {
                    lots.push(add_lot[0])
                } else {
                    toaster.pop('error', 'Problem Adding Lot ' + lot,
                        'Could not find the requested lot in the projects lot list');
                }
            }
        }

    	var new_qty = new_material.quantity / lots.length;

		_.each(lots, function(lot) {
            //var plan = $filter('filter')(lots, {'number': lot.item}, true);
			$scope.selectedReport.materials.push({
				delivery_price: new_material.delivery_price,
				foreman_note: (new_material.note)?new_material.note:'',
				lot: lot.number,
				name: new_material.name,
				plan_code: lot.plan,
                bid_note: '',
				price_per_order: new_material.price_per_order,
				quantity: new_qty,
                bid_quantity: 0,
				sales_tax: 0,
				sub_total: 0,
                total: 0,
                isInventory: new_material.isInventory
			});
		});

    	//update the database
    	$scope.selectedReport.materials =
            foremanPhaseService.combineSimilarItems($scope.selectedReport.materials);

        var consolidated_list =
            foremanPhaseService.consolidateOnForemanNotes(
                $scope.selectedReport.materials, $scope.companyFactors.sales_tax, false);

        $scope.selectedReport.bid_total =
            foremanPhaseService.getConsolidatedBidTotal(
                consolidated_list, $scope.companyFactors.sales_tax);

        var total = $scope.selectedReport.actual_total =
            foremanPhaseService.getConsolidatedActualTotal(
                consolidated_list, $scope.companyFactors.sales_tax);

        //$scope.saveOrUpdateMaterial();
        $scope.savedBidTotal = $scope.selectedReport.bid_total;
        this.new_material = this.$parent.new_material = new_material = {};

        if($scope.selectedReport._id) {
            $scope.selectedReport.$update(function(response) {
                $scope.updateDate(response);
                $scope.selectedReport.delivery_date = moment(response.delivery_date);
                $scope.selectedReport.actual_total = total;
                $scope.selectedReport.bid_total = $scope.savedBidTotal;
                $scope.getReportMaterialTotals();
            });
        } else {
            ProjectMaterials.query({
                'project_id': $scope.selectedProject._id,
                'complete': false,
                'phase': $scope.selectedReport.phase,
                'task_code': $scope.selectedReport.task_code,
                'submitted': true  }, function(projMatsDB) {
                $scope.selectedReport.sub_report_number = projMatsDB.length;
                $scope.selectedReport.$save(function(response) {
                    $scope.updateDate(response);
                    $scope.selectedReport.delivery_date = moment(response.delivery_date);
                    $scope.selectedReport.actual_total = total;
                    $scope.selectedReport.bid_total = $scope.savedBidTotal;
                    $scope.materialdb.push($scope.selectedReport);
                    $scope.getReportMaterialTotals();
                });
            });
        }

    	//update the view
    	this.materials_list = $scope.selectedReport.materials;
    	this.new_supplier =
    	this.new_category = '';
    };

    $scope.addConsolidatedMaterial = function(new_material) {
        $scope.addMaterial(new_material);
        $scope.submitMaterials();
        this.new_material = this.$parent.new_material = new_material = {};
        this.new_supplier =
        this.new_category = '';
    };

    $scope.addConsolidatedEquipment = function(new_equipment) {
        $scope.addEquipment(new_equipment);
        $scope.submitEquipment();
        this.new_equipment = this.$parent.new_equipment = new_equipment = {};
        this.new_supplier =
        this.new_category = '';
    };

    $scope.addEquipment = function(new_material) {
    	if(!new_material.delivery_price) new_material.delivery_price = 0;
        var lots = $filter('filter')($scope.selectedProject.lots, {
                'phase': $scope.selectedPhase.name }, true);

    	//first need to determine if we are adding across all lots or just one
    	if(new_material.all) {
    		var new_qty = new_material.quantity / lots.length;

    		_.each(lots, function(lot) {
    			$scope.selectedReport.equipment.push({
    				delivery_price: new_material.delivery_price,
    				foreman_note: (new_material.note)?new_material.note:'',
    				lot: lot.number,
    				name: new_material.name,
    				plan_code: lot.plan,
    				price_per_order: new_material.price_per_order,
    				quantity: new_qty,
                    bid_quantity: 0,
    				equipment_tax: 0,
    				sub_total: 0,
    				total: 0
    			});
    		});
    	} else {
    		var plan = $filter('filter')(lots, {
                'number': $scope.selectedReport.lots[0].item}, true);

            if(plan.length !== 1) {
                toaster.pop('error', 'Lot Error', 'Could not determine the lot');
                return;
            }

    		$scope.selectedReport.equipment.push({
				delivery_price: new_material.delivery_price,
				foreman_note: (new_material.note)?new_material.note:'',
				lot: $scope.selectedReport.lots[0].item,
				name: new_material.name,
				plan_code: plan[0].plan,
				price_per_order: new_material.price_per_order,
				quantity: new_material.quantity,
                bid_quantity: 0,
				equipment_tax: 0,
				sub_total: 0,
				total: 0
			});
    	}

    	//update the database
    	$scope.saveOrUpdateEquipment();

    	//update the view
    	this.equipment_list = $scope.selectedReport.equipment;
    	this.new_supplier =
    	this.new_category =
    	this.new_material = '';
    };

    $scope.getTradeCode = function(trade) {
    	return tradeCodeService.getCode(trade);
    };

    $scope.addMaterialReport = function() {
        //console.log($scope);
        //console.log(this);
        // var inlist = $filter('filter')($scope.material_reports, {
        //     'task_code': $scope.returnedMaterial.selectedTask.task_code,
        //     'supplier': $scope.returnedMaterial.selectedSupplier}, true);

        // if(inlist.length > 0) {
        //     toaster.pop('error', 'Adding Report', 'Report already exists.');
        //     return;
        // }

        var tasks = $filter('filter')($scope.my_tasks, {
            'task_code': $scope.returnedMaterial.selectedTask.task_code,
            'phase': $scope.selectedPhase.name }, true);

        if(tasks.length === 0) {
            toaster.pop('error', 'Project Tasks', 'Could not get a project task.');
            return;
        }

        var lots = [];
        for(var i=0; i<$scope.returnedMaterial.selectedLot.length; i++) {
            lots.push({
                item: $scope.returnedMaterial.selectedLot[i].number
            });
        }

        console.log(tasks);

        ProjectMaterials.query({
            'project_id': $scope.selectedProject._id,
            'complete': false,
            'phase': $scope.selectedPhase.name,
            'task_code': $scope.returnedMaterial.selectedTask.task_code,
            'submitted': true  }, function(projMatsDB) {

            var new_report = new ProjectMaterials({
                actual_total: 0,
                bid_total: 0,
                invoice_total: 0,
                invoice_date: moment(tasks[0].start_date),
                foreman_id: $scope.foreman_info._id,
                materials: [],
                phase: $scope.selectedPhase.name,
                lots: lots,
                main_report: false,
                //manually_entered: true,
                sub_report_number: projMatsDB.length,
                trade: $scope.trade.trade,
                project_id: $scope.selectedProject._id,
                project_task_id: tasks[0]._id,
                job_code: $scope.selectedProject.job_code,
                company_code: $scope.user.contractor_code,
                task_code: $scope.returnedMaterial.selectedTask.task_code,
                task_name: $scope.returnedMaterial.selectedTask.task_name,
                supplier: $scope.returnedMaterial.selectedSupplier,
                report_date: moment(tasks[0].start_date),
                start_date: moment(tasks[0].start_date),
                delivery_date: moment(tasks[0].start_date),
                userId: $scope.main_account._id
            });

            new_report.$save(function(response) {
                toaster.pop('success', 'Material Report Created');
                $scope.material_reports.push(response);

                $scope.selectedMaterial(response);
            }, function(error) {
                toaster.pop('error', 'Material Report Error', error);
            });
        });
    };

    $scope.addMaterialOperation = function() {
        taskListService.getByTrade(
            tradeCodeService.getCode(
                $scope.user.trade[0])).then(function(result) {

            result = $filter('orderBy')(result, 'task_code');
            var genTasks  = $filter('filter')(result, { geoLocation: $scope.selectedProject['geoLocation'], projectType: $scope.selectedProject['projectType']}, true);
            Materials.query({
                'trade_account': $scope.trade._id,
                'get_suppliers': true,
                'userId': $scope.main_account._id
            }, function(materials) {

                $scope.returnedMaterial = {
                    task_code: 'Task Code',
                    suppliers: materials,
                    task_list: genTasks,
                    lots: $scope.lots
                };

                ngDialog.openConfirm({
                    template: 'foreman/views/tmpl/foreman-add-material.html',
                    scope: $scope,
                    className: 'ngdialog-theme-default'
                }).then(function (value) {
                    $scope.addMaterialReport();
                }, function (value) {
                    //Do something
                    console.log('in the do something section');
                });
            });
        });
    };

    $scope.addEquipmentReport = function() {
        //console.log($scope);
        //console.log(this);
        var inlist = $filter('filter')($scope.equipment_reports, {
            'task_code': $scope.returnedEquipment.selectedTask.task_code,
            'supplier': $scope.returnedEquipment.selectedSupplier}, true);

        if(inlist.length > 0) {
            toaster.pop('error', 'Adding Report', 'Report already exists.');
            return;
        }

        var tasks = $filter('filter')($scope.my_tasks, {
            'task_code': $scope.returnedEquipment.selectedTask.task_code,
            'phase': $scope.selectedPhase.name }, true);

        if(tasks.length === 0) {
            toaster.pop('error', 'Project Tasks', 'Could not get a project task.');
            return;
        }

        var lots = [];

        _.each($scope.returnedEquipment.selectedLot, function(lot) {
            lots.push({
                item: lot.number
            });
        });

        ProjectEquipments.query({
            'project_id': $scope.selectedProject._id,
            'complete': false,
            'phase': $scope.selectedPhase.name,
            'task_code': $scope.returnedEquipment.selectedTask.task_code }, function(projMatsDB) {

            var new_report = new ProjectEquipments({
                actual_total: 0,
                bid_total: 0,
                invoice_total: 0,
                invoice_date: moment($scope.returnedEquipment.start_date),
                foreman_id: $scope.foreman_info._id,
                equipment: [],
                phase: $scope.selectedPhase.name,
                lots: lots,
                main_report: false,
                //manually_entered: true,
                sub_report_number: projMatsDB.length,
                trade: $scope.trade.trade,
                project_id: $scope.selectedProject._id,
                project_task_id: tasks[0]._id,
                job_code: $scope.selectedProject.job_code,
                company_code: $scope.user.contractor_code,
                task_code: $scope.returnedEquipment.selectedTask.task_code,
                task_name: $scope.returnedEquipment.selectedTask.task_name,
                supplier: $scope.returnedEquipment.selectedSupplier,
                report_date: moment($scope.returnedEquipment.start_date),
                start_date: moment($scope.returnedEquipment.start_date),
                delivery_date: moment($scope.returnedEquipment.start_date)
            });

            new_report.$save(function(response) {
                toaster.pop('success', 'Equipment Report Created');
                response.delivery_date = moment(response.delivery_date);
                $scope.equipment_reports.push(response);

                $scope.selectedEquipment(response);
            }, function(error) {
                toaster.pop('error', 'Equipment Report Error', error);
            });
        });
    };

    $scope.addEquipmentOperation = function() {
        taskListService.getByTrade(
            tradeCodeService.getCode(
                $scope.user.trade[0])).then(function(result) {

            result = $filter('orderBy')(result, 'task_code');
            var genTasks  = $filter('filter')(result, { geoLocation: $scope.selectedProject['geoLocation'], projectType: $scope.selectedProject['projectType']}, true);
            Equipments.query({'trade_account': $scope.trade._id,
                'get_suppliers': true}, function(materials) {

                $scope.returnedEquipment = {
                    task_code: 'Task Code',
                    suppliers: materials,
                    task_list: genTasks,
                    lots: $scope.lots
                };

                ngDialog.openConfirm({
                    template: 'foreman/views/tmpl/foreman-add-equipment.html',
                    scope: $scope,
                    className: 'ngdialog-theme-default'
                }).then(function (value) {
                    $scope.addEquipmentReport();
                }, function (value) {
                    //Do something
                    console.log('in the do something section');
                });
            });
        });
    };

    $scope.mergeReport = function() {
        if($scope.selectedMergeReport.merged) {
            toaster.pop('error', 'Merge Error', 'This report is already merged.');
            return;
        }

        if(!foremanPhaseService.lotsMatch(
            $scope.selectedMergeReport.lots, $scope.selectedReport.lots)) {
            toaster.pop('error', 'Merge Reports Error',
                'Lots must match.');

            return;
        }

        if($scope.mItem === 'Materials') {
            $scope.selectedMergeReport.materials =
                foremanPhaseService.combineSimilarItems(
                    $scope.selectedMergeReport.materials);

            _.remove($scope.selectedMergeReport.materials, function(mat) {
                return mat.quantity === 0;
            });

            _.each($scope.selectedMergeReport.materials, function(mat) {
                $scope.selectedReport.materials.push(mat);
            });

            $scope.selectedReport.materials = 
                foremanPhaseService.combineSimilarItems(
                    $scope.selectedReport.materials);

            $scope.selectedMergeReport.merged = true;
            if($scope.selectedMergeReport._id) {
                //update
                $scope.selectedMergeReport.$update(function(success){
                    var consolidated_list =
                        foremanPhaseService.consolidateOnForemanNotes(
                            $scope.selectedReport.materials, $scope.companyFactors.sales_tax, false);

                    $scope.selectedReport.bid_total =
                        foremanPhaseService.getConsolidatedBidTotal(
                            consolidated_list, $scope.companyFactors.sales_tax);

                    var total = $scope.selectedReport.actual_total =
                        foremanPhaseService.getConsolidatedActualTotal(
                            consolidated_list, $scope.companyFactors.sales_tax);

                    //$scope.saveOrUpdateMaterial();
                    $scope.savedBidTotal = $scope.selectedReport.bid_total;

                    if($scope.selectedReport._id) {
                        $scope.selectedReport.$update(function(response) {
                            $scope.updateDate(response);
                            $scope.selectedReport.delivery_date = moment(response.delivery_date);
                            $scope.selectedReport.actual_total = total;
                            $scope.selectedReport.bid_total = $scope.savedBidTotal;
                            $scope.getReportMaterialTotals();
                        });
                    } else {
                        ProjectMaterials.query({
                            'project_id': $scope.selectedProject._id,
                            'complete': false,
                            'phase': $scope.selectedReport.phase,
                            'task_code': $scope.selectedReport.task_code,
                            'submitted': true  }, function(projMatsDB) {
                            $scope.selectedReport.sub_report_number = projMatsDB.length;
                            $scope.selectedReport.$save(function(response) {
                                $scope.updateDate(response);
                                $scope.selectedReport.delivery_date = moment(response.delivery_date);
                                $scope.selectedReport.actual_total = total;
                                $scope.selectedReport.bid_total = $scope.savedBidTotal;
                                $scope.materialdb.push($scope.selectedReport);
                                $scope.getReportMaterialTotals();
                            });
                        });
                    }

                    var idx = $scope.mergable_reports.indexOf(success);
                    $scope.mergable_reports.splice(idx, 1);

                    $scope.material_reports =
                        foremanPhaseService.removedMerged(
                                $scope.material_reports);

                    $scope.submitMaterials();
                    $scope.getReportMaterialTotals()
                    toaster.pop('success', 'Report Merge', 'Report merge success');
                }, function(error) {
                    toaster.pop('error', 'Report Merge', 'Problem updating report to be merged.');
                });
            } else {
                $scope.selectedMergeReport.$save(function(success){
                    var consolidated_list =
                        foremanPhaseService.consolidateOnForemanNotes(
                            $scope.selectedReport.materials, $scope.companyFactors.sales_tax, false);

                    $scope.selectedReport.bid_total =
                        foremanPhaseService.getConsolidatedBidTotal(
                            consolidated_list, $scope.companyFactors.sales_tax);

                    var total = $scope.selectedReport.actual_total =
                        foremanPhaseService.getConsolidatedActualTotal(
                            consolidated_list, $scope.companyFactors.sales_tax);

                    //$scope.saveOrUpdateMaterial();
                    $scope.savedBidTotal = $scope.selectedReport.bid_total;

                    // _.each(consolidated_list, function(item) {
                    //     $scope.adjustSplitMaterialQuantityValues(
                    //         item, $scope.selectedReport, $scope.companyFactors.sales_tax);
                    // });

                    if($scope.selectedReport._id) {
                        $scope.selectedReport.$update(function(response) {
                            $scope.updateDate(response);
                            response.actual_total = total;
                            response.bid_total = $scope.savedBidTotal;
                            $scope.getReportMaterialTotals();
                        });
                    } else {
                        ProjectMaterials.query({
                            'project_id': $scope.selectedProject._id,
                            'complete': false,
                            'phase': $scope.selectedReport.phase,
                            'task_code': $scope.selectedReport.task_code,
                            'submitted': true  }, function(projMatsDB) {
                            $scope.selectedReport.sub_report_number = projMatsDB.length;
                            $scope.selectedReport.$save(function(response) {
                                $scope.updateDate(response);
                                response.actual_total = total;
                                response.bid_total = $scope.savedBidTotal;
                                $scope.materialdb.push($scope.selectedReport);
                                $scope.getReportMaterialTotals();
                            });
                        });
                    }

                    var idx = $scope.mergable_reports.indexOf(success);
                    $scope.mergable_reports.splice(idx, 1);

                    $scope.material_reports =
                        foremanPhaseService.removedMerged(
                                $scope.material_reports);

                    $scope.submitMaterials();
                    $scope.getReportMaterialTotals()
                    toaster.pop('success', 'Report Merge', 'Report merge success');
                }, function(error) {
                    toaster.pop('error', 'Report Merge', 'Problem saving report to be merged.');
                });
            }
        } else {
            _.each($scope.selectedMergeReport.equipment, function(eq) {
                $scope.selectedReport.equipment.push(eq);
            });

            $scope.selectedMergeReport.merged = true;
            if($scope.selectedMergeReport._id) {
                //update
                $scope.selectedMergeReport.$update(function(success){
                    $scope.saveOrUpdateEquipment();

                    var idx = $scope.mergable_reports.indexOf(success);
                    $scope.mergable_reports.splice(idx, 1);

                    $scope.equipment_reports =
                        foremanPhaseService.removedMerged(
                                $scope.equipment_reports);
                    toaster.pop('success', 'Report Merge', 'Report merge success');
                }, function(error) {
                    toaster.pop('error', 'Report Merge', 'Problem updating report to be merged.');
                });
            } else {
                //save
                ProjectMaterials.query({
                    'project_id': $scope.selectedProject._id,
                    'complete': false,
                    'phase': $scope.selectedReport.phase,
                    'task_code': $scope.selectedReport.task_code,
                    'submitted': true  }, function(projMatsDB) {
                    $scope.selectedMergeReport.sub_report_number = projMatsDB.length;
                    $scope.selectedMergeReport.$save(function(success){
                        $scope.saveOrUpdateEquipment();

                        var idx = $scope.mergable_reports.indexOf(success);
                        $scope.mergable_reports.splice(idx, 1);

                        $scope.equipment_reports =
                            foremanPhaseService.removedMerged(
                                    $scope.equipment_reports);
                        toaster.pop('success', 'Report Merge', 'Report merge success');
                    }, function(error) {
                        toaster.pop('error', 'Report Merge', 'Problem saving report to be merged.');
                    });
                });
            }
        }
    };

    $scope.mergeReportOperation = function() {
        $scope.selectedMergeReport = this.selectedMergeReport;
        ngDialog.openConfirm({
            template:
                '<h2>Merge Report Confirm</h2>' +
                '<p>This will merge the selected report to the current report</p>' +
                '<p>This operation cannot be undone </p>' +
                '<p>Are you sure you wish to continue? </p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;</button>' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            scope: $scope,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            $scope.mergeReport();

            //I'm leaving this here for now.  I'd like to update the list
            //in the view but it's forcing a change event and causing
            //the dialog box to pop up a second time.  Comment out for now.
            //var idx = $scope.mergable_reports.indexOf($scope.selectedMergeReport);
            //$scope.mergable_reports.splice(idx, 1);

            $scope.selectedMergeReport = '';
        }, function (value) {
            //Do something
            console.log('in the do something section');
        });

        this.selectedMergeReport = '';
    };

    $scope.removeUnsubMaterialOperation = function() {
        ngDialog.openConfirm({
            template:
                '<h2>Remove Unsubmitted Material Reports Confirm</h2>' +
                '<p>This operation will remove all unsubmitted material reports that currently exist.  This will require you to go back through and update any quantity or note information for reports not yet submitted.</p>' +
                '<p>This operation cannot be undone </p>' +
                '<p>Are you sure you wish to continue? </p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;</button>' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            scope: $scope,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            ProjectMaterials.query({
                'project_id': $scope.selectedProject._id,
                'complete': false,
                'phase': $scope.selectedPhase.name}, function(materialdb) {

                var promises = [];
                var deleted_reports = $q.defer();

                _.each(materialdb, function(report) {
                    if(report.submitted === false) {
                        report.$delete(function(success) {
                            promises.push(success);
                        }, function(error) {
                            toaster.pop('error', 'Remove Report Error', error);
                        });
                    }
                });

                $q.all(promises).then(function(result) {
                    $state.reload();
                    //$scope.changePhase($scope.selectedPhase);
                });
            });
        }, function (value) {
            //Do something
            console.log('in the do something section');
        });
    };

    $scope.removeUnsubEquipmentOperation = function() {
        ngDialog.openConfirm({
            template:
                '<h2>Remove Unsubmitted Equipment Reports Confirm</h2>' +
                '<p>This operation will remove all unsubmitted equipment reports that currently exist.  This will require you to go back through and update any quantity or note information for reports not yet submitted.</p>' +
                '<p>This operation cannot be undone </p>' +
                '<p>Are you sure you wish to continue? </p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;</button>' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            scope: $scope,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            ProjectEquipments.query({
                'project_id': $scope.selectedProject._id,
                'complete': false,
                'phase': $scope.selectedPhase.name}, function(materialdb) {

                var promises = [];
                var deleted_reports = $q.defer();

                _.each(materialdb, function(report) {
                    if(report.submitted === false) {
                        report.$delete(function(success) {
                            promises.push(success);
                        }, function(error) {
                            toaster.pop('error', 'Remove Report Error', error);
                        });
                    }
                });

                $q.all(promises).then(function(result) {
                    $state.reload();
                });
            });
        }, function (value) {
            //Do something
            console.log('in the do something section');
        });
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/foreman/public/controllers/foreman_phase.js